import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Label } from '../../components/ui/label';
import { Users, Plus, Zap, Shield, Settings, BookOpen, Archive, Activity, FileText, BarChart3, UserPlus, Trash2, Edit, Search, Target, Trophy, AlertTriangle, ChevronDown, Eye, Filter, UserCheck, Lock, Calendar, TrendingUp, Download, Clock, CheckCircle, XCircle, PlayCircle, Copy, GraduationCap, FileCheck, ClipboardList, Globe, MessageSquare, Maximize2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/api';
import { grupoGuiasService } from '../../services/grupoGuias';
import { fechamentosService } from '../../services/fechamentos';
import { enqueueSnackbar } from 'notistack';
import { Grupo, MilitarGrupo, GrupoTipoAcao } from '../../types/grupos';
import { ProvaComEstatisticas, ProvaAcesso, CreateProvaData } from '../../types/provas';
import { GrupoTurma } from '../../types/turmas';
import { Relatorio, RelatorioCategoria, RelatorioEstatisticas } from '../../types/relatorios';
import { provasService } from '../../services/provas';
import { turmasAPI } from '../../services/turmas';
import { relatoriosAPI } from '../../services/relatorios';
import { useGroupPermissions, useUserGroups } from '../../hooks/useUserGroups';
import { GrupoMembrosModal } from '../../components/modals';
import { TipoAcaoModal } from '../../components/modals/TipoAcaoModal';
import { CampoAcaoModal } from '../../components/modals/CampoAcaoModal';
import { GrupoGuiaModal, VisualizarFechamentoModal } from '../../components/modals';
import { GuiaViewer } from '../../components/GuiaViewer';
import { GuiaViewerPIP } from '../../components/GuiaViewerPIP';
import { GrupoAcoesManager } from '../../components/GrupoAcoesManager';
import { GrupoAcoesAprovacaoList } from '../../components/GrupoAcoesAprovacaoList';
import { GrupoFechamentosManager } from '../../components/GrupoFechamentosManager';
import { GrupoInscricoesManager } from '../../components/GrupoInscricoesManager';
import { GrupoOuvidoriaManager } from '../../components/GrupoOuvidoriaManager';
import { GrupoGuiasManager } from '../../components/GrupoGuiasManager';
import QuestoesManager from '../../components/modals/QuestoesManager';
import GerenciarAcessosModal from '../../components/modals/GerenciarAcessosModal';
import { RealizarProvaModal } from '../../components/modals/RealizarProvaModal';
import { DivulgarResultadosModal } from '../../components/modals/DivulgarResultadosModal';
import { TurmaModal } from '../../components/modals/TurmaModal';
import { GerenciarMembrosModal } from '../../components/modals/GerenciarMembrosModal';
import { GerenciarNotasModal } from '../../components/modals/GerenciarNotasModal';
import { RelatorioModal } from '../../components/modals/RelatorioModal';
import { VisualizarRelatorioModal } from '../../components/modals/VisualizarRelatorioModal';
import { DatePickerField } from '../../components/DatePickerField';
import {
  GrupoHeader,
  CreateFechamentoModal,
  CreateProvaModal,
  EditProvaModal,
  MEMBER_STATUS,
  STATUS_COLORS,
  getCategoriaInfo
} from './components';

export function GrupoPage() {
  const { grupoNome } = useParams<{ grupoNome: string }>();
  const navigate = useNavigate();

  const [grupoId, setGrupoId] = useState<string | undefined>(undefined);

  const [grupo, setGrupo] = useState<Grupo | null>(null);
  const [membros, setMembros] = useState<MilitarGrupo[]>([]);
  const [tiposAcoes, setTiposAcoes] = useState<GrupoTipoAcao[]>([]);
  const [gruposCargos, setGruposCargos] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [isGrupoMembrosModalOpen, setIsGrupoMembrosModalOpen] = useState(false);
  const [openMembrosModalInAddMode, setOpenMembrosModalInAddMode] = useState(false);
  const [activeTab, setActiveTab] = useState<'principal' | 'membros' | 'tipos-acoes' | 'guias' | 'fechamentos' | 'gestao-provas' | 'minhas-provas' | 'turmas' | 'meus-relatorios' | 'relatorios' | 'inscricoes' | 'ouvidoria'>('principal');
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [possuiTurmas, setPossuiTurmas] = useState(false);
  const [possuiSiteTextos, setPossuiSiteTextos] = useState(false);
  const [possuiInscricoes, setPossuiInscricoes] = useState(false);
  const [possuiOuvidoria, setPossuiOuvidoria] = useState(false);
  const [dbrEnabled, setDbrEnabled] = useState(false);
  const [refreshAcoesTrigger, setRefreshAcoesTrigger] = useState(0);

  // Estados para modal de tipos de ações
  const [isTipoAcaoModalOpen, setIsTipoAcaoModalOpen] = useState(false);
  const [tipoAcaoToEdit, setTipoAcaoToEdit] = useState<GrupoTipoAcao | null>(null);
  const [searchTerm, setSearchTerm] = useState('');

  // Estados para modal de campos de ação
  const [campoModalOpen, setCampoModalOpen] = useState(false);
  const [tipoAcaoParaCampos, setTipoAcaoParaCampos] = useState<GrupoTipoAcao | null>(null);

  // Estados para modal de confirmação de exclusão
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [tipoAcaoToDelete, setTipoAcaoToDelete] = useState<GrupoTipoAcao | null>(null);

  // Estados para modal de remoção de membro
  const [removeMembroModalOpen, setRemoveMembroModalOpen] = useState(false);
  const [membroToRemove, setMembroToRemove] = useState<MilitarGrupo | null>(null);
  const [motivoRemocao, setMotivoRemocao] = useState('');

  // Estados para alteração de status de membros
  const [statusDropdownOpen, setStatusDropdownOpen] = useState<string | null>(null);
  const [cargoDropdownOpen, setCargoDropdownOpen] = useState<string | null>(null);
  const [memberSearchTerm, setMemberSearchTerm] = useState('');

  // Estados para guias
  const [guias, setGuias] = useState<any[]>([]);
  const [loadingGuias, setLoadingGuias] = useState(false);
  const [guiaSearchTerm, setGuiaSearchTerm] = useState('');
  const [isGuiaModalOpen, setIsGuiaModalOpen] = useState(false);
  const [selectedGuia, setSelectedGuia] = useState<any | null>(null);
  const [isGuiaViewerOpen, setIsGuiaViewerOpen] = useState(false);
  const [viewingGuiaId, setViewingGuiaId] = useState<string | null>(null);
  const [guiaToDeletePage, setGuiaToDeletePage] = useState<any | null>(null);
  const [pipGuiaId, setPipGuiaId] = useState<string | null>(null);

  // Estados para fechamentos
  const [fechamentos, setFechamentos] = useState<any[]>([]);
  const [loadingFechamentos, setLoadingFechamentos] = useState(false);
  const [fechamentoDateStart, setFechamentoDateStart] = useState('');
  const [fechamentoDateEnd, setFechamentoDateEnd] = useState('');
  const [isFechamentoModalOpen, setIsFechamentoModalOpen] = useState(false);
  const [isVisualizarFechamentoModalOpen, setIsVisualizarFechamentoModalOpen] = useState(false);
  const [selectedFechamento, setSelectedFechamento] = useState<any | null>(null);

  // Estados para provas
  const [provas, setProvas] = useState<ProvaComEstatisticas[]>([]);
  const [minhasProvas, setMinhasProvas] = useState<ProvaAcesso[]>([]);
  const [isCreateProvaModalOpen, setIsCreateProvaModalOpen] = useState(false);
  const [provaSearchTerm, setProvaSearchTerm] = useState('');
  const [provaToEdit, setProvaToEdit] = useState<ProvaComEstatisticas | null>(null);
  const [loadingProvas, setLoadingProvas] = useState(false);
  const [isQuestoesManagerOpen, setIsQuestoesManagerOpen] = useState(false);
  const [selectedProvaForQuestoes, setSelectedProvaForQuestoes] = useState<ProvaComEstatisticas | null>(null);
  const [isGerenciarAcessosModalOpen, setIsGerenciarAcessosModalOpen] = useState(false);
  const [selectedProvaForAcessos, setSelectedProvaForAcessos] = useState<ProvaComEstatisticas | null>(null);
  const [isRealizarProvaModalOpen, setIsRealizarProvaModalOpen] = useState(false);
  const [isDivulgarResultadosModalOpen, setIsDivulgarResultadosModalOpen] = useState(false);
  const [provaParaDivulgarResultados, setProvaParaDivulgarResultados] = useState<ProvaComEstatisticas | null>(null);
  const [acessoParaRealizar, setAcessoParaRealizar] = useState<ProvaAcesso | null>(null);
  const [openProvaMenuId, setOpenProvaMenuId] = useState<string | null>(null);
  const [provaConfirmModalOpen, setProvaConfirmModalOpen] = useState(false);
  const [provaConfirmType, setProvaConfirmType] = useState<'duplicar' | 'desativar' | 'excluir' | null>(null);
  const [provaConfirmTarget, setProvaConfirmTarget] = useState<ProvaComEstatisticas | null>(null);

  // Estados para turmas
  const [turmas, setTurmas] = useState<any[]>([]);
  const [isTurmaModalOpen, setIsTurmaModalOpen] = useState(false);
  const [turmaToEdit, setTurmaToEdit] = useState<any | null>(null);
  const [isMembrosModalOpen, setIsMembrosModalOpen] = useState(false);
  const [turmaParaMembros, setTurmaParaMembros] = useState<any | null>(null);
  const [isNotasModalOpen, setIsNotasModalOpen] = useState(false);
  const [turmaParaNotas, setTurmaParaNotas] = useState<any | null>(null);

  // Estados para relatórios
  const [meusRelatorios, setMeusRelatorios] = useState<any[]>([]);
  const [relatorios, setRelatorios] = useState<any[]>([]);
  const [isRelatorioModalOpen, setIsRelatorioModalOpen] = useState(false);
  const [relatorioToEdit, setRelatorioToEdit] = useState<any | null>(null);
  const [isVisualizarRelatorioModalOpen, setIsVisualizarRelatorioModalOpen] = useState(false);
  const [relatorioParaVisualizar, setRelatorioParaVisualizar] = useState<any | null>(null);
  const [estatisticasRelatorios, setEstatisticasRelatorios] = useState<any>(null);
  const [filtroTurmaRelatorios, setFiltroTurmaRelatorios] = useState<string>('');
  const [filtroCategoriaRelatorios, setFiltroCategoriaRelatorios] = useState<string>('');
  const [isConfirmarRelatorioModalOpen, setIsConfirmarRelatorioModalOpen] = useState(false);
  const [relatorioToConfirmar, setRelatorioToConfirmar] = useState<any | null>(null);

  // Usar uma única instância para garantir sincronização
  const {
    canManageMembers,
    canManageActions,
    isMember,
    isAdmin,
    isResponsavel,
    isLoading: isLoadingUserGroups,
    reloadGroups,
    grupos: userGroups
  } = useGroupPermissions();

  // Ordem do cargo do admin logado neste grupo
  const ordemCargoAdmin = useMemo(() => {
    const membership = userGroups.find(g => g.grupo.id === grupoId);
    return membership?.grupoCargo?.ordem ?? 0;
  }, [userGroups, grupoId]);

  // Verificar permissões específicas para o grupo atual
  const canManageGroup = grupoId ? canManageMembers(grupoId) && canManageActions(grupoId) : false;
  const isAdminOfGroup = grupoId ? isAdmin(grupoId) : false;
  const isResponsavelOfGroup = grupoId ? isResponsavel(grupoId) : false;
  const isJustMember = !isAdminOfGroup && !isResponsavelOfGroup;

  // Permissões específicas por recurso
  const canCreateTurma = isAdminOfGroup; // Apenas admins podem criar turmas
  const canEditTurma = isAdminOfGroup; // Apenas admins podem editar turmas
  const canManageTurmaMembros = !isJustMember; // Admins e responsáveis podem gerenciar membros de turmas
  const canAccessGestaoProvas = isAdminOfGroup; // Apenas admins têm acesso à gestão de provas
  const canAccessTiposAcoes = isAdminOfGroup; // Apenas admins têm acesso a tipos de ações

  // Recarregar grupos do usuário quando entrar na página para garantir dados atualizados
  useEffect(() => {
    if (grupoId) {
      reloadGroups(true); // Silencioso para não afetar menu
    }
  }, [grupoId, reloadGroups]);

  useEffect(() => {
    if (grupoNome && !isLoadingUserGroups) {
      loadGrupoData();
    }
  }, [grupoNome, isLoadingUserGroups]);

  // Carregar minhas provas sempre que a tab for ativada ou o grupo mudar
  useEffect(() => {
    if (activeTab === 'minhas-provas' && grupoId) {
      loadMinhasProvas();
    }
  }, [activeTab, grupoId]);

  // Carregar provas (gestão) sempre que a tab for ativada
  useEffect(() => {
    if (activeTab === 'gestao-provas' && grupoId) {
      loadProvas();
    }
  }, [activeTab, grupoId]);

  // Carregar turmas quando a tab for ativada
  useEffect(() => {
    if (activeTab === 'turmas' && grupoId) {
      loadTurmas();
    }
  }, [activeTab, grupoId]);

  // Carregar meus relatórios quando a tab for ativada
  useEffect(() => {
    if (activeTab === 'meus-relatorios' && grupoId) {
      loadMeusRelatorios();
    }
  }, [activeTab, grupoId]);

  // Carregar relatórios (admin) quando a tab for ativada
  const [relatoriosLoaded, setRelatoriosLoaded] = useState(false);
  useEffect(() => {
    if (activeTab === 'relatorios' && grupoId && !relatoriosLoaded) {
      setRelatoriosLoaded(true);
      loadRelatorios();
      loadTurmas(); // Carregar turmas para o filtro
    }
    // Reset quando mudar de tab
    if (activeTab !== 'relatorios') {
      setRelatoriosLoaded(false);
    }
  }, [activeTab, grupoId, relatoriosLoaded]);

  // Carregar guias quando a tab for ativada
  useEffect(() => {
    if (activeTab === 'guias' && grupoId) {
      loadGuias();
    }
  }, [activeTab, grupoId]);

  // Carregar fechamentos quando a tab for ativada
  useEffect(() => {
    if (activeTab === 'fechamentos' && grupoId) {
      loadFechamentos();
    }
  }, [activeTab, grupoId]);

  // Fechar dropdown de status quando clicar fora
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (statusDropdownOpen) {
        const target = event.target as Element;
        if (!target.closest('.status-dropdown')) {
          setStatusDropdownOpen(null);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [statusDropdownOpen]);

  // Fechar dropdown de cargo quando clicar fora
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (cargoDropdownOpen) {
        const target = event.target as Element;
        if (!target.closest('.cargo-dropdown')) {
          setCargoDropdownOpen(null);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [cargoDropdownOpen]);

  // Fechar menu de ações das provas quando pressionar Escape
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpenProvaMenuId(null);
      }
    };

    if (openProvaMenuId) {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [openProvaMenuId]);

  // Limpar dados quando o grupo mudar
  useEffect(() => {
    // Limpar dados das provas quando mudar de grupo
    setMinhasProvas([]);
    setProvas([]);
  }, [grupoId]);

  const loadGrupoData = async () => {
    if (!grupoNome) return;

    try {
      setLoading(true);

      // Resolver nome do grupo para ID e carregar dados
      const grupoRes = await api.get(`/grupos/nome/${grupoNome}`);
      const resolvedGrupoId = grupoRes.data.id;
      setGrupoId(resolvedGrupoId);
      setGrupo(grupoRes.data);

      // Carregar demais dados do grupo usando o ID resolvido
      const [membrosRes, tiposAcoesRes, cargosRes, configuracoesRes] = await Promise.all([
        api.get(`/militares-grupos/grupo/${resolvedGrupoId}/ativos`),
        api.get(`/grupos-tipos-acoes/grupo/${resolvedGrupoId}`),
        api.get('/grupos-cargos'),
        api.get(`/grupos-configuracoes/grupo/${resolvedGrupoId}`)
      ]);
      setMembros(Array.isArray(membrosRes.data) ? membrosRes.data : []);
      setTiposAcoes(Array.isArray(tiposAcoesRes.data) ? tiposAcoesRes.data : []);
      setGruposCargos(Array.isArray(cargosRes.data) ? cargosRes.data : []);

      // Processar configurações
      const configuracoes = Array.isArray(configuracoesRes.data) ? configuracoesRes.data : [];
      const possuiTurmasConfig = configuracoes.find((c: any) => c.chave === 'possui_turmas');
      setPossuiTurmas(possuiTurmasConfig?.valor === 'true' || possuiTurmasConfig?.valor === true);
      const possuiSiteTextosConfig = configuracoes.find((c: any) => c.chave === 'possui_site_textos');
      setPossuiSiteTextos(possuiSiteTextosConfig?.valor === 'true' || possuiSiteTextosConfig?.valor === true);
      const dbrConfig = configuracoes.find((c: any) => c.chave === 'dbr');
      setDbrEnabled(dbrConfig?.valor === 'true' || dbrConfig?.valor === true);
      const possuiInscricoesConfig = configuracoes.find((c: any) => c.chave === 'possui_inscricoes');
      setPossuiInscricoes(!!possuiInscricoesConfig);
      const ouvidoriaConfig = configuracoes.find((c: any) => c.chave === 'ouvidoria');
      setPossuiOuvidoria(!!ouvidoriaConfig);

      // Guias, fechamentos e provas são carregados sob demanda ao acessar cada tab
    } catch (error: any) {
      console.error('Erro ao carregar dados do grupo:', error);

      // Se for erro 403 ou 404, provavelmente não tem acesso
      if (error.response?.status === 403 || error.response?.status === 404) {
        // Força reload dos grupos do usuário para atualizar o menu
        await reloadGroups(true);
        enqueueSnackbar('Você não tem acesso a este grupo', { variant: 'error' });
        navigate('/dashboard');
      } else {
        enqueueSnackbar('Erro ao carregar informações do grupo', { variant: 'error' });
      }
    } finally {
      setLoading(false);
    }
  };

  const loadGuias = async () => {
    if (!grupoId) return;
    try {
      setLoadingGuias(true);
      const guiasResponse = await grupoGuiasService.listar(grupoId);
      setGuias(Array.isArray(guiasResponse.guias) ? guiasResponse.guias : []);
    } catch (error: any) {
      console.error('Erro ao carregar guias:', error);
      setGuias([]);
    } finally {
      setLoadingGuias(false);
    }
  };

  const loadMembros = async () => {
    if (!grupoId) return;
    try {
      const membrosRes = await api.get(`/militares-grupos/grupo/${grupoId}/ativos`);
      setMembros(Array.isArray(membrosRes.data) ? membrosRes.data : []);
    } catch (error: any) {
      console.error('Erro ao carregar membros:', error);
      setMembros([]);
    }
  };

  const loadFechamentos = async () => {
    if (!grupoId) return;
    try {
      setLoadingFechamentos(true);
      const fechamentosResponse = await fechamentosService.listar({ id_grupo: grupoId });
      setFechamentos(Array.isArray(fechamentosResponse.fechamentos) ? fechamentosResponse.fechamentos : []);
    } catch (error: any) {
      console.error('Erro ao carregar fechamentos:', error);
      setFechamentos([]);
    } finally {
      setLoadingFechamentos(false);
    }
  };

  const loadProvas = async () => {
    if (!grupoId) return;
    try {
      const provasResponse = await provasService.listarPorGrupoComEstatisticas(grupoId);
      setProvas(Array.isArray(provasResponse) ? provasResponse : []);
    } catch (error: any) {
      console.error('Erro ao carregar provas:', error);
      setProvas([]);
    }
  };

  const loadMinhasProvas = async () => {
    try {
      if (!grupoId) {
        setMinhasProvas([]);
        return;
      }

      // Limpar a lista antes de carregar para evitar dados antigos
      setMinhasProvas([]);

      const minhasProvasResponse = await provasService.listarMinhasProvasPorGrupo(grupoId);

      // Garantir que sempre seja um array, mesmo se a resposta for null/undefined
      const provasArray = Array.isArray(minhasProvasResponse) ? minhasProvasResponse : [];

      setMinhasProvas(provasArray);
    } catch (error: any) {
      console.error('Erro ao carregar minhas provas:', error);
      setMinhasProvas([]);
    }
  };

  const loadTurmas = async () => {
    try {
      if (!grupoId) return;
      const turmasData = await turmasAPI.listarPorGrupo(grupoId);
      setTurmas(turmasData);
    } catch (error) {
      console.error('Erro ao carregar turmas:', error);
      enqueueSnackbar('Erro ao carregar turmas', { variant: 'error' });
    }
  };

  const loadMeusRelatorios = async () => {
    try {
      if (!grupoId) return;
      const relatoriosData = await relatoriosAPI.listarMeus(grupoId);
      setMeusRelatorios(relatoriosData);

      const stats = await relatoriosAPI.getEstatisticas(grupoId, false);
      setEstatisticasRelatorios(stats);
    } catch (error) {
      console.error('Erro ao carregar meus relatórios:', error);
      enqueueSnackbar('Erro ao carregar relatórios', { variant: 'error' });
    }
  };

  const loadRelatorios = async () => {
    try {
      if (!grupoId) return;
      const relatoriosData = await relatoriosAPI.listarTodos(grupoId);
      setRelatorios(relatoriosData);

      const stats = await relatoriosAPI.getEstatisticas(grupoId, true);
      setEstatisticasRelatorios(stats);
    } catch (error) {
      console.error('Erro ao carregar relatórios:', error);
      enqueueSnackbar('Erro ao carregar relatórios', { variant: 'error' });
    }
  };

  const handleAddMembro = () => {
    if (canManageMembers(grupoId!)) {
      setIsGrupoMembrosModalOpen(true);
    } else {
      enqueueSnackbar('Você não tem permissão para gerenciar membros deste grupo', { variant: 'error' });
    }
  };

  const handleAddTipoAcao = () => {
    if (canManageActions(grupoId!)) {
      setTipoAcaoToEdit(null);
      setIsTipoAcaoModalOpen(true);
    } else {
      enqueueSnackbar('Você não tem permissão para gerenciar ações deste grupo', { variant: 'error' });
    }
  };

  const handleEditTipoAcao = (tipoAcao: GrupoTipoAcao) => {
    if (canManageActions(grupoId!)) {
      setTipoAcaoToEdit(tipoAcao);
      setIsTipoAcaoModalOpen(true);
    } else {
      enqueueSnackbar('Você não tem permissão para gerenciar ações deste grupo', { variant: 'error' });
    }
  };

  const handleDeleteTipoAcao = (tipoAcao: GrupoTipoAcao) => {
    if (!canManageActions(grupoId!)) {
      enqueueSnackbar('Você não tem permissão para gerenciar ações deste grupo', { variant: 'error' });
      return;
    }

    setTipoAcaoToDelete(tipoAcao);
    setDeleteConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!tipoAcaoToDelete) return;

    try {
      await api.delete(`/grupos-tipos-acoes/${tipoAcaoToDelete.id}`);
      enqueueSnackbar('Tipo de ação excluído com sucesso!', { variant: 'success' });
      loadGrupoData(); // Recarregar dados
    } catch (error: any) {
      console.error('Erro ao excluir tipo de ação:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao excluir tipo de ação', { variant: 'error' });
    } finally {
      setDeleteConfirmOpen(false);
      setTipoAcaoToDelete(null);
    }
  };

  const handleTipoAcaoModalSuccess = () => {
    setIsTipoAcaoModalOpen(false);
    setTipoAcaoToEdit(null);
    loadGrupoData(); // Recarregar dados
  };

  const handleOpenCamposModal = (tipoAcao: GrupoTipoAcao) => {
    setTipoAcaoParaCampos(tipoAcao);
    setCampoModalOpen(true);
  };

  const handleCloseCamposModal = () => {
    setCampoModalOpen(false);
    setTipoAcaoParaCampos(null);
  };

  const handleCamposModalSuccess = () => {
    // Pode recarregar dados se necessário
  };

  // Funções para gerenciar guias
  const handleCreateGuia = () => {
    if (canManageActions(grupoId!)) {
      setSelectedGuia(null);
      setIsGuiaModalOpen(true);
    } else {
      enqueueSnackbar('Você não tem permissão para gerenciar guias deste grupo', { variant: 'error' });
    }
  };

  const handleEditGuia = (guia: any) => {
    if (canManageActions(grupoId!)) {
      setSelectedGuia(guia);
      setIsGuiaModalOpen(true);
    } else {
      enqueueSnackbar('Você não tem permissão para gerenciar guias deste grupo', { variant: 'error' });
    }
  };

  const handleViewGuia = async (guia: any) => {
    setViewingGuiaId(guia.id);
    setIsGuiaViewerOpen(true);
  };

  const handleDeleteGuia = (guia: any) => {
    if (!canManageActions(grupoId!)) {
      enqueueSnackbar('Você não tem permissão para gerenciar guias deste grupo', { variant: 'error' });
      return;
    }
    setGuiaToDeletePage(guia);
  };

  const handleConfirmDeleteGuia = async () => {
    if (!guiaToDeletePage) return;
    try {
      await grupoGuiasService.excluir(guiaToDeletePage.id);
      enqueueSnackbar('Guia excluída com sucesso!', { variant: 'success' });
      loadGuias();
    } catch (error: any) {
      console.error('Erro ao excluir guia:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao excluir guia', { variant: 'error' });
    } finally {
      setGuiaToDeletePage(null);
    }
  };

  const handleGuiaModalClose = () => {
    setIsGuiaModalOpen(false);
    setSelectedGuia(null);
  };

  const handleGuiaModalSave = async (isNewGuia?: boolean) => {
    setIsGuiaModalOpen(false);
    setSelectedGuia(null);
    // Só recarrega se criou/editou uma guia (não apenas fechou)
    if (isNewGuia !== false) {
      loadGuias();
    }
  };

  const handleGuiaViewerClose = () => {
    setIsGuiaViewerOpen(false);
    setViewingGuiaId(null);
    // NÃO recarrega - apenas visualizou
  };

  // Funções para gerenciar fechamentos
  const handleCreateFechamento = () => {
    if (canManageActions(grupoId!)) {
      setIsFechamentoModalOpen(true);
    } else {
      enqueueSnackbar('Você não tem permissão para gerenciar fechamentos deste grupo', { variant: 'error' });
    }
  };

  const handleViewFechamento = (fechamento: any) => {
    setSelectedFechamento(fechamento);
    setIsVisualizarFechamentoModalOpen(true);
  };

  const handleFechamentoModalClose = () => {
    setIsFechamentoModalOpen(false);
  };

  const handleFechamentoModalSave = () => {
    setIsFechamentoModalOpen(false);
    loadFechamentos();
  };

  const handleVisualizarFechamentoModalClose = () => {
    setIsVisualizarFechamentoModalOpen(false);
    setSelectedFechamento(null);
  };

  const handleFinalizarFechamento = async (fechamentoId: string) => {
    if (!canManageActions(grupoId!)) {
      enqueueSnackbar('Você não tem permissão para finalizar fechamentos', { variant: 'error' });
      return;
    }

    try {
      await fechamentosService.finalizarFechamento(fechamentoId);
      enqueueSnackbar('Fechamento finalizado com sucesso! Status dos membros atualizados.', { variant: 'success' });
      loadFechamentos();
    } catch (error: any) {
      console.error('Erro ao finalizar fechamento:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao finalizar fechamento', { variant: 'error' });
    }
  };

  const handleUpdateMemberStatus = async (memberId: string, newStatus: string) => {
    if (!canManageMembers(grupoId!)) {
      enqueueSnackbar('Você não tem permissão para gerenciar membros deste grupo', { variant: 'error' });
      return;
    }

    try {
      await api.put(`/militares-grupos/${memberId}`, { status: newStatus });
      enqueueSnackbar('Status do membro atualizado com sucesso!', { variant: 'success' });
      setStatusDropdownOpen(null);

      // Otimização: Atualiza apenas o membro no estado local ao invés de recarregar tudo
      setMembros(prevMembros =>
        prevMembros.map(m =>
          m.id === memberId ? { ...m, status: newStatus } : m
        )
      );
    } catch (error: any) {
      console.error('Erro ao atualizar status do membro:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao atualizar status do membro', { variant: 'error' });
    }
  };

  const handleUpdateMemberCargo = async (memberId: string, novoCargoId: string) => {
    if (!isAdminOfGroup) {
      enqueueSnackbar('Apenas administradores do grupo podem alterar cargos', { variant: 'error' });
      return;
    }

    try {
      await api.patch(`/militares-grupos/${memberId}/cargo`, { id_grupo_cargo: novoCargoId });
      enqueueSnackbar('Cargo do membro atualizado com sucesso!', { variant: 'success' });
      setCargoDropdownOpen(null);

      // Otimização: Atualiza apenas o cargo do membro no estado local
      const novoCargo = gruposCargos.find(c => c.id === novoCargoId);
      setMembros(prevMembros =>
        prevMembros.map(m =>
          m.id === memberId ? { ...m, grupoCargo: novoCargo } : m
        )
      );
    } catch (error: any) {
      console.error('Erro ao atualizar cargo do membro:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao alterar cargo do membro', { variant: 'error' });
    }
  };

  const handleRemoveMember = async () => {
    if (!membroToRemove || !canManageMembers(grupoId!)) {
      enqueueSnackbar('Você não tem permissão para gerenciar membros deste grupo', { variant: 'error' });
      return;
    }

    try {
      await api.patch(`/militares-grupos/militar/${membroToRemove.militar.id}/grupo/${grupoId}/remover`, {
        motivo_remocao: motivoRemocao.trim() || undefined
      });
      enqueueSnackbar('Membro removido com sucesso!', { variant: 'success' });

      // Otimização: Remove o membro do estado local ao invés de recarregar tudo
      setMembros(prevMembros => prevMembros.filter(m => m.id !== membroToRemove.id));

      setRemoveMembroModalOpen(false);
      setMembroToRemove(null);
      setMotivoRemocao('');
    } catch (error: any) {
      console.error('Erro ao remover membro:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao remover membro', { variant: 'error' });
    }
  };

  const handleOpenRemoveModal = (membro: MilitarGrupo) => {
    setMembroToRemove(membro);
    setMotivoRemocao('');
    setRemoveMembroModalOpen(true);
  };

  const handleCloseRemoveModal = () => {
    setRemoveMembroModalOpen(false);
    setMembroToRemove(null);
    setMotivoRemocao('');
  };

  // Funções para manipulação de provas
  const handleCreateProva = async (data: CreateProvaData) => {
    if (!canManageGroup) {
      enqueueSnackbar('Você não tem permissão para gerenciar provas deste grupo', { variant: 'error' });
      return;
    }

    try {
      setLoadingProvas(true);
      await provasService.criar({ ...data, id_grupo: grupoId! });
      enqueueSnackbar('Prova criada com sucesso!', { variant: 'success' });
      setIsCreateProvaModalOpen(false);
      loadProvas();
    } catch (error: any) {
      console.error('Erro ao criar prova:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao criar prova', { variant: 'error' });
    } finally {
      setLoadingProvas(false);
    }
  };

  const handleEditProva = (prova: ProvaComEstatisticas) => {
    if (!canManageGroup) {
      enqueueSnackbar('Você não tem permissão para editar provas deste grupo', { variant: 'error' });
      return;
    }
    setProvaToEdit(prova);
  };

  const handleUpdateProva = async (data: CreateProvaData) => {
    if (!provaToEdit) return;

    try {
      setLoadingProvas(true);
      await provasService.atualizar(provaToEdit.id, data);
      enqueueSnackbar('Prova atualizada com sucesso!', { variant: 'success' });
      setProvaToEdit(null);
      loadProvas();
    } catch (error: any) {
      console.error('Erro ao atualizar prova:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao atualizar prova', { variant: 'error' });
    } finally {
      setLoadingProvas(false);
    }
  };

  const handleToggleProvaStatus = async (prova: ProvaComEstatisticas) => {
    if (!canManageGroup) {
      enqueueSnackbar('Você não tem permissão para gerenciar provas deste grupo', { variant: 'error' });
      return;
    }

    try {
      await provasService.alternarStatus(prova.id);
      enqueueSnackbar(`Prova ${prova.ativa ? 'desativada' : 'ativada'} com sucesso!`, { variant: 'success' });
      loadProvas();
    } catch (error: any) {
      console.error('Erro ao alterar status da prova:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao alterar status da prova', { variant: 'error' });
    }
  };

  const handleDivulgarResultado = (prova: ProvaComEstatisticas) => {
    if (!canManageGroup) {
      enqueueSnackbar('Você não tem permissão para gerenciar provas deste grupo', { variant: 'error' });
      return;
    }

    setProvaParaDivulgarResultados(prova);
    setIsDivulgarResultadosModalOpen(true);
  };

  const handleGerenciarAcessos = (prova: ProvaComEstatisticas) => {
    if (!canManageGroup) {
      enqueueSnackbar('Você não tem permissão para gerenciar acessos deste grupo', { variant: 'error' });
      return;
    }
    setSelectedProvaForAcessos(prova);
    setIsGerenciarAcessosModalOpen(true);
  };

  const handleDeleteProva = async (prova: ProvaComEstatisticas) => {
    if (!canManageGroup) {
      enqueueSnackbar('Você não tem permissão para gerenciar provas deste grupo', { variant: 'error' });
      return;
    }

    try {
      await provasService.excluir(prova.id);
      enqueueSnackbar('Prova excluída com sucesso!', { variant: 'success' });
      loadProvas();
    } catch (error: any) {
      console.error('Erro ao excluir prova:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao excluir prova', { variant: 'error' });
    }
  };

  const handleDuplicarProva = async (prova: ProvaComEstatisticas) => {
    if (!canManageGroup) {
      enqueueSnackbar('Você não tem permissão para gerenciar provas deste grupo', { variant: 'error' });
      return;
    }

    try {
      await provasService.duplicarProva(prova.id);
      enqueueSnackbar('Prova duplicada com sucesso!', { variant: 'success' });
      loadProvas();
    } catch (error: any) {
      console.error('Erro ao duplicar prova:', error);
      enqueueSnackbar(error.response?.data?.message || 'Erro ao duplicar prova', { variant: 'error' });
    }
  };

  // Funções para realizar prova
  const handleIniciarProva = (acesso: ProvaAcesso) => {
    setAcessoParaRealizar(acesso);
    setIsRealizarProvaModalOpen(true);
  };

  const handleContinuarProva = (acesso: ProvaAcesso) => {
    setAcessoParaRealizar(acesso);
    setIsRealizarProvaModalOpen(true);
  };

  const handleFinalizarProva = async () => {
    // Recarregar dados das provas após finalizar
    await loadMinhasProvas();
    setIsRealizarProvaModalOpen(false);
    setAcessoParaRealizar(null);
  };

  // Filtrar tipos de ações baseado no termo de busca
  const filteredTiposAcoes = tiposAcoes.filter(tipo =>
    tipo.descricao.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Retorna há quanto tempo o membro está com o status atual
  const getTempoNoStatus = (alterado_em: string): string => {
    const agora = new Date();
    const alterado = new Date(alterado_em);
    const diffMs = agora.getTime() - alterado.getTime();
    const diffMin = Math.floor(diffMs / 60000);
    const diffH = Math.floor(diffMin / 60);
    const diffD = Math.floor(diffH / 24);
    const diffM = Math.floor(diffD / 30);
    const diffA = Math.floor(diffM / 12);
    if (diffA >= 1) return `há ${diffA} ano${diffA > 1 ? 's' : ''}`;
    if (diffM >= 1) return `há ${diffM} mês${diffM > 1 ? 'es' : ''}`;
    if (diffD >= 1) return `há ${diffD} dia${diffD > 1 ? 's' : ''}`;
    if (diffH >= 1) return `há ${diffH} hora${diffH > 1 ? 's' : ''}`;
    if (diffMin >= 1) return `há ${diffMin} minuto${diffMin > 1 ? 's' : ''}`;
    return 'agora mesmo';
  };

  // Filtrar membros baseado no termo de busca
  const filteredMembros = membros.filter(membro =>
    membro.militar.nick.toLowerCase().includes(memberSearchTerm.toLowerCase())
  );

  // Filtrar guias baseado no termo de busca
  const filteredGuias = guias.filter(guia =>
    guia.titulo.toLowerCase().includes(guiaSearchTerm.toLowerCase()) ||
    (guia.descricao && guia.descricao.toLowerCase().includes(guiaSearchTerm.toLowerCase()))
  );

  // Filtrar fechamentos baseado no range de datas
  const filteredFechamentos = fechamentos.filter(fechamento => {
    if (!fechamentoDateStart && !fechamentoDateEnd) return true;

    const fechamentoDate = new Date(fechamento.data_fechamento);
    const startDate = fechamentoDateStart ? new Date(fechamentoDateStart) : null;
    const endDate = fechamentoDateEnd ? new Date(fechamentoDateEnd) : null;

    if (startDate && fechamentoDate < startDate) return false;
    if (endDate && fechamentoDate > endDate) return false;

    return true;
  });

  // Filtrar provas baseado no termo de busca
  const filteredProvas = provas.filter(prova =>
    prova.titulo.toLowerCase().includes(provaSearchTerm.toLowerCase()) ||
    (prova.descricao && prova.descricao.toLowerCase().includes(provaSearchTerm.toLowerCase()))
  );

  // Filtrar minhas provas para mostrar apenas as do grupo atual
  const filteredMinhasProvas = minhasProvas.filter(acesso =>
    acesso.prova.id && acesso.id_prova // Verificar se a prova pertence ao grupo atual seria ideal, mas não temos esse campo direto
  );

  if (loading || isLoadingUserGroups) {
    return (
      <div className="p-6">
        <div className="animate-pulse space-y-6">
          <div className="h-8 bg-muted rounded w-1/4"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="h-48 bg-muted rounded"></div>
            <div className="h-48 bg-muted rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!grupo) {
    return (
      <div className="p-6">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-foreground mb-4">Grupo não encontrado</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <GrupoHeader grupo={grupo} />

      {/* Sistema de Tabs — mobile: menu dropdown / desktop: tabs horizontais */}

      {/* MOBILE NAV */}
      <div className="md:hidden border-b border-border pb-3">
        <button
          onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
          className="w-full flex items-center justify-between px-4 py-2.5 rounded-lg border border-border bg-muted/40 text-sm font-medium text-foreground"
        >
          <span className="flex items-center gap-2">
            {activeTab === 'principal' && <Activity className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'membros' && <Users className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'guias' && <BookOpen className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'meus-relatorios' && <FileText className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'minhas-provas' && <Trophy className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'turmas' && <GraduationCap className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'gestao-provas' && <Target className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'relatorios' && <FileCheck className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'fechamentos' && <BarChart3 className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'tipos-acoes' && <Zap className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'inscricoes' && <ClipboardList className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {activeTab === 'ouvidoria' && <MessageSquare className="h-4 w-4 text-[oklch(0.45_0.15_142)]" />}
            {{
              'principal': 'Principal',
              'membros': 'Membros',
              'guias': 'Guias & Apostilas',
              'meus-relatorios': 'Meus Relatórios',
              'minhas-provas': 'Minhas Provas',
              'turmas': 'Turmas',
              'gestao-provas': 'Provas',
              'relatorios': 'Relatórios',
              'fechamentos': 'Fechamentos',
              'tipos-acoes': 'Tipos de Ações',
              'inscricoes': 'Inscrições',
              'ouvidoria': 'Ouvidoria',
            }[activeTab]}
          </span>
          <ChevronDown className={`h-4 w-4 transition-transform ${isMobileNavOpen ? 'rotate-180' : ''}`} />
        </button>

        {isMobileNavOpen && (
          <div className="relative z-50 mt-1 rounded-lg border border-border bg-card shadow-md overflow-hidden">
            {([
              { id: 'principal', label: 'Principal', icon: <Activity className="h-4 w-4" />, show: true },
              { id: 'membros', label: 'Membros', icon: <Users className="h-4 w-4" />, show: true },
              { id: 'guias', label: 'Guias & Apostilas', icon: <BookOpen className="h-4 w-4" />, show: true },
              { id: 'meus-relatorios', label: 'Meus Relatórios', icon: <FileText className="h-4 w-4" />, show: possuiTurmas },
              { id: 'minhas-provas', label: 'Minhas Provas', icon: <Trophy className="h-4 w-4" />, show: possuiTurmas },
              { id: 'turmas', label: 'Turmas', icon: <GraduationCap className="h-4 w-4" />, show: !isJustMember && possuiTurmas },
              { id: 'gestao-provas', label: 'Provas', icon: <Target className="h-4 w-4" />, show: !isJustMember && possuiTurmas && isAdminOfGroup },
              { id: 'relatorios', label: 'Relatórios', icon: <FileCheck className="h-4 w-4" />, show: !isJustMember && possuiTurmas },
              { id: 'fechamentos', label: 'Fechamentos', icon: <BarChart3 className="h-4 w-4" />, show: !isJustMember },
              { id: 'tipos-acoes', label: 'Tipos de Ações', icon: <Zap className="h-4 w-4" />, show: !isJustMember && isAdminOfGroup },
              { id: 'inscricoes', label: 'Inscrições', icon: <ClipboardList className="h-4 w-4" />, show: !isJustMember && possuiInscricoes },
              { id: 'ouvidoria', label: 'Ouvidoria', icon: <MessageSquare className="h-4 w-4" />, show: isAdminOfGroup && possuiOuvidoria },
            ] as const).filter(t => t.show).map(t => (
              <button
                key={t.id}
                onClick={() => { setActiveTab(t.id as typeof activeTab); setIsMobileNavOpen(false); }}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm border-b border-border last:border-0 transition-colors ${
                  activeTab === t.id
                    ? 'bg-[oklch(0.45_0.15_142)]/10 text-[oklch(0.45_0.15_142)] font-medium'
                    : 'text-foreground hover:bg-muted'
                }`}
              >
                <span className={activeTab === t.id ? 'text-[oklch(0.45_0.15_142)]' : 'text-muted-foreground'}>{t.icon}</span>
                {t.label}
              </button>
            ))}
            {isAdminOfGroup && possuiSiteTextos && (
              <button
                onClick={() => { navigate(`/grupos/${grupoNome}/texto-site`); setIsMobileNavOpen(false); }}
                className="w-full flex items-center gap-3 px-4 py-3 text-sm border-b border-border last:border-0 text-foreground hover:bg-muted transition-colors"
              >
                <Globe className="h-4 w-4 text-muted-foreground" />
                Texto Site
              </button>
            )}
          </div>
        )}
      </div>

      {/* DESKTOP NAV */}
      <div className="hidden md:block border-b border-border relative">
        <nav className="flex gap-2 overflow-visible" aria-label="Tabs">
          {/* Tab Principal */}
          <button
            onClick={() => setActiveTab('principal')}
            className={`${
              activeTab === 'principal'
                ? 'border-[oklch(0.45_0.15_142)] text-[oklch(0.45_0.15_142)]'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            } inline-flex items-center px-4 py-2 border-b-2 font-medium text-sm whitespace-nowrap transition-colors`}
          >
            <Activity className={`${
              activeTab === 'principal' ? 'text-[oklch(0.45_0.15_142)]' : 'text-muted-foreground'
            } -ml-0.5 mr-2 h-5 w-5`} />
            Principal
          </button>

          {/* Tab Membros */}
          <button
            onClick={() => setActiveTab('membros')}
            className={`${
              activeTab === 'membros'
                ? 'border-[oklch(0.45_0.15_142)] text-[oklch(0.45_0.15_142)]'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            } inline-flex items-center px-4 py-2 border-b-2 font-medium text-sm whitespace-nowrap transition-colors`}
          >
            <Users className={`${
              activeTab === 'membros' ? 'text-[oklch(0.45_0.15_142)]' : 'text-muted-foreground'
            } -ml-0.5 mr-2 h-5 w-5`} />
            Membros
          </button>

          {/* Guias & Apostilas */}
          <button
            onClick={() => setActiveTab('guias')}
            className={`${
              activeTab === 'guias'
                ? 'border-[oklch(0.45_0.15_142)] text-[oklch(0.45_0.15_142)]'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            } inline-flex items-center px-4 py-2 border-b-2 font-medium text-sm whitespace-nowrap transition-colors`}
          >
            <BookOpen className={`${
              activeTab === 'guias' ? 'text-[oklch(0.45_0.15_142)]' : 'text-muted-foreground'
            } -ml-0.5 mr-2 h-5 w-5`} />
            Guias & Apostilas
          </button>

          {/* Meus Relatórios - Apenas se possui_turmas = true */}
          {possuiTurmas && (
            <button
              onClick={() => setActiveTab('meus-relatorios')}
              className={`${
                activeTab === 'meus-relatorios'
                  ? 'border-[oklch(0.45_0.15_142)] text-[oklch(0.45_0.15_142)]'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
              } inline-flex items-center px-4 py-2 border-b-2 font-medium text-sm whitespace-nowrap transition-colors`}
            >
              <FileText className={`${
                activeTab === 'meus-relatorios' ? 'text-[oklch(0.45_0.15_142)]' : 'text-muted-foreground'
              } -ml-0.5 mr-2 h-5 w-5`} />
              Meus Relatórios
            </button>
          )}

          {/* Minhas Provas - Apenas se possui_turmas = true */}
          {possuiTurmas && (
            <button
              onClick={() => setActiveTab('minhas-provas')}
              className={`${
                activeTab === 'minhas-provas'
                  ? 'border-[oklch(0.45_0.15_142)] text-[oklch(0.45_0.15_142)]'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
              } inline-flex items-center px-4 py-2 border-b-2 font-medium text-sm whitespace-nowrap transition-colors`}
            >
              <Trophy className={`${
                activeTab === 'minhas-provas' ? 'text-[oklch(0.45_0.15_142)]' : 'text-muted-foreground'
              } -ml-0.5 mr-2 h-5 w-5`} />
              Minhas Provas
            </button>
          )}

          {/* Dropdown Formação (apenas para admins/responsaveis e se possui_turmas = true) */}
          {!isJustMember && possuiTurmas && (
            <div className="relative">
              <button
                onClick={() => setOpenDropdown(openDropdown === 'formacao' ? null : 'formacao')}
                className={`${
                  ['turmas', 'gestao-provas', 'relatorios'].includes(activeTab)
                    ? 'border-[oklch(0.45_0.15_142)] text-[oklch(0.45_0.15_142)]'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
                } inline-flex items-center px-4 py-2 border-b-2 font-medium text-sm whitespace-nowrap transition-colors`}
              >
                <GraduationCap className={`${
                  ['turmas', 'gestao-provas', 'relatorios'].includes(activeTab) ? 'text-[oklch(0.45_0.15_142)]' : 'text-muted-foreground'
                } -ml-0.5 mr-2 h-5 w-5`} />
                Formação
                <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              {openDropdown === 'formacao' && (
                <div className="absolute left-0 top-full mt-1 w-48 bg-white dark:bg-card rounded-md shadow-lg border border-gray-200 dark:border-border z-50">
                  <button
                    onClick={() => { setActiveTab('turmas'); setOpenDropdown(null); }}
                    className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-muted flex items-center gap-2 text-foreground"
                  >
                    <GraduationCap className="h-4 w-4" /> Turmas
                  </button>
                  {/* Provas apenas para Admins */}
                  {isAdminOfGroup && (
                    <button
                      onClick={() => { setActiveTab('gestao-provas'); setOpenDropdown(null); }}
                      className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-muted flex items-center gap-2 text-foreground"
                    >
                      <Target className="h-4 w-4" /> Provas
                    </button>
                  )}
                  <button
                    onClick={() => { setActiveTab('relatorios'); setOpenDropdown(null); }}
                    className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-muted flex items-center gap-2 text-foreground"
                  >
                    <FileCheck className="h-4 w-4" /> Relatórios
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Dropdown Gestão (diferentes opções para admins e responsáveis) */}
          {!isJustMember && (
            <div className="relative">
              <button
                onClick={() => setOpenDropdown(openDropdown === 'gestao' ? null : 'gestao')}
                className={`${
                  ['fechamentos', 'tipos-acoes', 'inscricoes', 'ouvidoria'].includes(activeTab)
                    ? 'border-[oklch(0.45_0.15_142)] text-[oklch(0.45_0.15_142)]'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
                } inline-flex items-center px-4 py-2 border-b-2 font-medium text-sm whitespace-nowrap transition-colors`}
              >
                <Settings className={`${
                  ['fechamentos', 'tipos-acoes', 'inscricoes', 'ouvidoria'].includes(activeTab) ? 'text-[oklch(0.45_0.15_142)]' : 'text-muted-foreground'
                } -ml-0.5 mr-2 h-5 w-5`} />
                Gestão
                <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              {openDropdown === 'gestao' && (
                <div className="absolute left-0 top-full mt-1 w-48 bg-white dark:bg-card rounded-md shadow-lg border border-gray-200 dark:border-border z-50">
                  <button
                    onClick={() => { setActiveTab('fechamentos'); setOpenDropdown(null); }}
                    className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-muted flex items-center gap-2 text-foreground"
                  >
                    <BarChart3 className="h-4 w-4" /> Fechamentos
                  </button>
                  {/* Tipos de Ações apenas para Admins */}
                  {isAdminOfGroup && (
                    <button
                      onClick={() => { setActiveTab('tipos-acoes'); setOpenDropdown(null); }}
                      className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-muted flex items-center gap-2 text-foreground"
                    >
                      <Zap className="h-4 w-4" /> Tipos de Ações
                    </button>
                  )}
                  {/* Texto Site apenas para Admins e se possui_site_textos = true */}
                  {isAdminOfGroup && possuiSiteTextos && (
                    <button
                      onClick={() => { navigate(`/grupos/${grupoNome}/texto-site`); setOpenDropdown(null); }}
                      className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-muted flex items-center gap-2 text-foreground"
                    >
                      <Globe className="h-4 w-4" /> Texto Site
                    </button>
                  )}
                  {/* Inscrições se o grupo tiver o módulo habilitado */}
                  {possuiInscricoes && (
                    <button
                      onClick={() => { setActiveTab('inscricoes'); setOpenDropdown(null); }}
                      className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-muted flex items-center gap-2 text-foreground"
                    >
                      <ClipboardList className="h-4 w-4" /> Inscrições
                    </button>
                  )}
                  {/* Ouvidoria se o grupo tiver o módulo habilitado */}
                  {isAdminOfGroup && possuiOuvidoria && (
                    <button
                      onClick={() => { setActiveTab('ouvidoria'); setOpenDropdown(null); }}
                      className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-muted flex items-center gap-2 text-foreground"
                    >
                      <MessageSquare className="h-4 w-4" /> Ouvidoria
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
        </nav>
      </div>

      {/* Fechar dropdown desktop ao clicar fora */}
      {openDropdown && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setOpenDropdown(null)}
        />
      )}

      {/* Fechar menu mobile ao clicar fora */}
      {isMobileNavOpen && (
        <div
          className="fixed inset-0 z-40 md:hidden"
          onClick={() => setIsMobileNavOpen(false)}
        />
      )}

      {/* Conteúdo das Tabs */}
      <div className="mt-6">
        {activeTab === 'principal' && (
          <div className="space-y-6">
            {/* Cards de Funcionalidades - Apenas para Admins e Responsáveis */}
            {!isJustMember && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Card de Membros */}
                <Card className="border-l-4 border-l-blue-500">
                  <CardHeader>
                    <CardTitle className="text-blue-700 flex items-center gap-2">
                      <Users className="w-5 h-5" />
                      Membros ({membros.length})
                    </CardTitle>
                    <CardDescription>
                      {canManageMembers(grupoId!) ? 'Gerencie os membros deste grupo' : 'Visualize os membros deste grupo'}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-4">
                      <div className="grid grid-cols-3 gap-4 text-sm">
                <div>
                  <span className="font-medium">Admins:</span> {membros.filter(m => m.grupoCargo?.admin).length}
                </div>
                <div>
                  <span className="font-medium">Responsáveis:</span> {membros.filter(m => m.grupoCargo?.responsavel).length}
                </div>
                <div>
                  <span className="font-medium">Membros:</span> {membros.filter(m => !m.grupoCargo?.admin && !m.grupoCargo?.responsavel).length}
                </div>
              </div>

              <div className="space-y-2">
                <Button
                  onClick={() => setActiveTab('membros')}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                >
                  <Users className="w-4 h-4 mr-2" />
                  Ver Membros
                </Button>

                {canManageMembers(grupoId!) && (
                  <Button
                    onClick={() => {
                      setOpenMembrosModalInAddMode(true);
                      setIsGrupoMembrosModalOpen(true);
                    }}
                    variant="outline"
                    className="w-full"
                  >
                    <UserPlus className="w-4 h-4 mr-2" />
                    Gerenciar Membros
                  </Button>
                )}

                {!canManageMembers(grupoId!) && (
                  <p className="text-xs text-gray-500 text-center">
                    Apenas Admins e Responsáveis podem gerenciar membros
                  </p>
                )}
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Card de Tipos de Ações - Apenas para Admins */}
        {isAdminOfGroup && (
          <Card className="border-l-4 border-l-green-500">
            <CardHeader>
              <CardTitle className="text-green-700 flex items-center gap-2">
                <Zap className="w-5 h-5" />
                Ações Disponíveis ({tiposAcoes.length})
              </CardTitle>
              <CardDescription>
                Configure os tipos de ações disponíveis
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div className="space-y-2">
                  <Button
                    onClick={() => setActiveTab('tipos-acoes')}
                    className="w-full bg-green-600 hover:bg-green-700 text-white"
                  >
                    <Zap className="w-4 h-4 mr-2" />
                    Gerenciar Tipos de Ações
                  </Button>
                  <p className="text-xs text-gray-500 text-center">
                    Apenas Admins podem gerenciar tipos de ações
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        )}
              </div>
            )}

            {/* Gerenciador de Ações do Grupo */}
            <GrupoAcoesManager
              grupoId={grupoId!}
              canCreateActions={isMember(grupoId!)}
              onActionCreated={() => setRefreshAcoesTrigger(prev => prev + 1)}
            />

            {/* Lista de Ações e Aprovações */}
            <GrupoAcoesAprovacaoList
              key={refreshAcoesTrigger}
              grupoId={grupoId!}
              canApprove={canManageActions(grupoId!)}
              filterByCurrentUser={isJustMember}
              dbrEnabled={dbrEnabled}
            />
          </div>
        )}

        {activeTab === 'guias' && (
          <div className="space-y-6">
            {/* Header com título e botão */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
              <h2 className="text-2xl font-bold text-foreground">Guias & Apostilas</h2>
              {canManageActions(grupoId!) && (
                <Button
                  onClick={handleCreateGuia}
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Novo Guia
                </Button>
              )}
            </div>

            {loadingGuias ? (
              <div className="animate-pulse space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
                  {[...Array(4)].map((_, i) => <div key={i} className="h-20 bg-muted rounded" />)}
                </div>
                <div className="h-10 bg-muted rounded" />
                <div className="h-48 bg-muted rounded" />
              </div>
            ) : (
            <>
            {/* Cards de estatísticas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <BookOpen className="h-8 w-8 text-blue-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total</p>
                      <p className="text-2xl font-bold text-foreground">{guias.length}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Activity className="h-8 w-8 text-green-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Ativas</p>
                      <p className="text-2xl font-bold text-foreground">
                        {guias.filter(g => g.status === 'ativo').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Eye className="h-8 w-8 text-purple-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Visualizações</p>
                      <p className="text-2xl font-bold text-foreground">
                        {guias.reduce((sum, g) => sum + (g.visualizacoes || 0), 0)}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Filter className="h-8 w-8 text-orange-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Categorias</p>
                      <p className="text-2xl font-bold text-foreground">
                        {new Set(guias.filter(g => g.categoria).map(g => g.categoria)).size}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Campo de busca */}
            <div className="flex items-center space-x-4">
              <div className="flex-1 relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <input
                  type="text"
                  placeholder="Buscar guias por título ou descrição..."
                  value={guiaSearchTerm}
                  onChange={(e) => setGuiaSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-border rounded-md bg-background text-foreground focus:ring-ring focus:border-ring"
                />
              </div>
            </div>

            {/* Lista de guias */}
            <Card>
              <CardHeader>
                <CardTitle>Lista de Guias</CardTitle>
              </CardHeader>
              <CardContent>
                {filteredGuias.length === 0 ? (
                  <div className="text-center py-8">
                    <BookOpen className="mx-auto h-12 w-12 text-muted-foreground/50" />
                    <h3 className="mt-2 text-sm font-medium text-foreground">
                      {guiaSearchTerm ? 'Nenhuma guia encontrada' : 'Nenhuma guia cadastrada'}
                    </h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      {guiaSearchTerm ? 'Tente buscar com outros termos.' : 'Comece criando uma nova guia.'}
                    </p>
                    {!guiaSearchTerm && canManageActions(grupoId!) && (
                      <div className="mt-6">
                        <Button
                          onClick={handleCreateGuia}
                          className="bg-blue-600 hover:bg-blue-700 text-white"
                        >
                          <Plus className="h-4 w-4 mr-2" />
                          Criar Primeira Guia
                        </Button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="space-y-4">
                    {filteredGuias.map((guia) => (
                      <div key={guia.id} className="border border-border rounded-lg p-4 hover:bg-muted/50 dark:hover:bg-muted/30">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-wrap items-center gap-2">
                              <Badge
                                className={
                                  guia.status === 'ativo' ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300' :
                                  guia.status === 'rascunho' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300' :
                                  'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300'
                                }
                              >
                                {guia.status === 'ativo' ? 'Ativa' :
                                 guia.status === 'rascunho' ? 'Rascunho' : 'Inativa'}
                              </Badge>

                              <h3 className="text-lg font-medium text-foreground">{guia.titulo}</h3>

                              {guia.categoria && (
                                <Badge variant="outline" className="bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
                                  {guia.categoria}
                                </Badge>
                              )}

                              <div className="flex items-center gap-1 px-2 py-1 rounded-md bg-muted">
                                {guia.tipo_acesso === 'publico' ? (
                                  <Users className="h-4 w-4 text-green-600" />
                                ) : guia.tipo_acesso === 'restrito' ? (
                                  <UserCheck className="h-4 w-4 text-orange-600" />
                                ) : guia.tipo_acesso === 'admin' ? (
                                  <Shield className="h-4 w-4 text-red-600" />
                                ) : (
                                  <Lock className="h-4 w-4 text-gray-600" />
                                )}
                                <span className="text-xs text-muted-foreground">
                                  {guia.tipo_acesso === 'publico' ? 'Todos' :
                                   guia.tipo_acesso === 'restrito' ? 'Restrito' :
                                   guia.tipo_acesso === 'admin' ? 'Admin' : 'Privado'}
                                </span>
                              </div>
                            </div>

                            {guia.descricao && (
                              <p className="mt-2 text-sm text-muted-foreground">{guia.descricao}</p>
                            )}

                            <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
                              <span>Por: {guia.militarCriador?.nick || 'Desconhecido'}</span>
                              <span>Criado em {new Date(guia.criado_em).toLocaleDateString('pt-BR')}</span>
                              <span className="flex items-center gap-1">
                                <Eye className="h-3 w-3" />
                                {guia.visualizacoes || 0} visualizações
                              </span>
                            </div>
                          </div>

                          <div className="flex flex-wrap gap-2 sm:shrink-0">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => handleViewGuia(guia)}
                              className="text-blue-600 hover:text-blue-700 hover:bg-blue-50 dark:hover:bg-blue-900/20"
                            >
                              <Eye className="h-4 w-4 mr-1" />
                              Visualizar
                            </Button>
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => setPipGuiaId(guia.id)}
                              className="text-purple-600 hover:text-purple-700 hover:bg-purple-50 dark:hover:bg-purple-900/20"
                              title="Abrir em janela flutuante"
                            >
                              <Maximize2 className="h-4 w-4 mr-1" />
                              Janela
                            </Button>

                            {canManageActions(grupoId!) && (
                              <>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => handleEditGuia(guia)}
                                >
                                  <Edit className="h-4 w-4 mr-1" />
                                  Editar
                                </Button>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => handleDeleteGuia(guia)}
                                  className="text-red-600 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/20"
                                >
                                  <Trash2 className="h-4 w-4 mr-1" />
                                  Excluir
                                </Button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
            </>
            )}
          </div>
        )}

        {activeTab === 'membros' && (
          <div className="space-y-6">
            {/* Header com título e botão */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
              <h2 className="text-2xl font-bold text-foreground">Membros do Grupo</h2>
              {canManageMembers(grupoId!) && (
                <Button
                  onClick={() => {
                    setOpenMembrosModalInAddMode(true);
                    setIsGrupoMembrosModalOpen(true);
                  }}
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Adicionar Membro
                </Button>
              )}
            </div>

            {/* Cards de estatísticas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-3">
              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Users className="h-8 w-8 text-blue-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total</p>
                      <p className="text-2xl font-bold text-foreground">{membros.length}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Shield className="h-8 w-8 text-yellow-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Em Verificação</p>
                      <p className="text-2xl font-bold text-foreground">
                        {membros.filter(m => m.status === 'V').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Activity className="h-8 w-8 text-green-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Ativos</p>
                      <p className="text-2xl font-bold text-foreground">
                        {membros.filter(m => m.status === 'A').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Archive className="h-8 w-8 text-orange-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Semi-Ausentes</p>
                      <p className="text-2xl font-bold text-foreground">
                        {membros.filter(m => m.status === 'S').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <UserPlus className="h-8 w-8 text-red-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Ausentes</p>
                      <p className="text-2xl font-bold text-foreground">
                        {membros.filter(m => m.status === 'AU').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Campo de busca */}
            <div className="flex items-center space-x-4">
              <div className="flex-1 relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <input
                  type="text"
                  placeholder="Buscar membros pelo nick..."
                  value={memberSearchTerm}
                  onChange={(e) => setMemberSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-border rounded-md bg-background text-foreground focus:ring-ring focus:border-ring"
                />
              </div>
            </div>

            {/* Lista de membros */}
            <Card>
              <CardHeader>
                <CardTitle>Lista de Membros</CardTitle>
              </CardHeader>
              <CardContent>
                {filteredMembros.length === 0 ? (
                  <div className="text-center py-8">
                    <Users className="mx-auto h-12 w-12 text-muted-foreground/50" />
                    <h3 className="mt-2 text-sm font-medium text-foreground">
                      {memberSearchTerm ? 'Nenhum membro encontrado' : 'Nenhum membro cadastrado'}
                    </h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      {memberSearchTerm ? 'Tente buscar com outros termos.' : 'Comece adicionando um novo membro.'}
                    </p>
                    {!memberSearchTerm && canManageMembers(grupoId!) && (
                      <div className="mt-6">
                        <Button
                          onClick={() => {
                            setOpenMembrosModalInAddMode(true);
                            setIsGrupoMembrosModalOpen(true);
                          }}
                          className="bg-blue-600 hover:bg-blue-700 text-white"
                        >
                          <Plus className="h-4 w-4 mr-2" />
                          Adicionar Primeiro Membro
                        </Button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="space-y-4">
                    {filteredMembros.map((membro) => (
                      <div key={membro.id} className="border border-border rounded-lg p-4 hover:bg-muted/50 dark:hover:bg-muted/30">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-wrap items-center gap-2">
                              {canManageMembers(grupoId!) ? (
                                <div className="relative status-dropdown">
                                  <button
                                    onClick={() => setStatusDropdownOpen(statusDropdownOpen === membro.id ? null : membro.id)}
                                    className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${STATUS_COLORS[membro.status as keyof typeof STATUS_COLORS] || 'bg-gray-100 text-gray-800'} hover:opacity-80 transition-opacity`}
                                  >
                                    {MEMBER_STATUS[membro.status as keyof typeof MEMBER_STATUS] || membro.status}
                                    <ChevronDown className="h-3 w-3 ml-1" />
                                  </button>

                                  {statusDropdownOpen === membro.id && (
                                    <div className="absolute left-0 mt-1 w-48 bg-background border border-border rounded-md shadow-lg z-10">
                                      <div className="py-1">
                                        {Object.entries(MEMBER_STATUS).map(([key, label]) => (
                                          <button
                                            key={key}
                                            onClick={() => handleUpdateMemberStatus(membro.id, key)}
                                            className={`w-full text-left px-4 py-2 text-sm hover:bg-muted flex items-center justify-between ${
                                              membro.status === key ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300' : 'text-foreground'
                                            }`}
                                          >
                                            <span className="flex items-center gap-1.5">
                                              {key === 'D' && <span>⭐</span>}
                                              {label}
                                            </span>
                                            {membro.status === key && (
                                              <div className="w-2 h-2 bg-blue-600 rounded-full" />
                                            )}
                                          </button>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <Badge className={STATUS_COLORS[membro.status as keyof typeof STATUS_COLORS] || 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300'}>
                                  {MEMBER_STATUS[membro.status as keyof typeof MEMBER_STATUS] || membro.status}
                                </Badge>
                              )}

                              <h3 className="text-lg font-medium text-foreground">
                                {membro.militar.patente?.abreviacao} {membro.militar.nick}
                              </h3>

                              {isAdminOfGroup ? (
                                <div className="relative cargo-dropdown">
                                  <button
                                    onClick={() => setCargoDropdownOpen(cargoDropdownOpen === membro.id ? null : membro.id)}
                                    className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border border-border bg-background hover:bg-muted transition-colors"
                                  >
                                    {membro.grupoCargo?.cargo}
                                    {membro.grupoCargo?.admin && ' • Admin'}
                                    {membro.grupoCargo?.responsavel && ' • Responsável'}
                                    <ChevronDown className="h-3 w-3 ml-1" />
                                  </button>

                                  {cargoDropdownOpen === membro.id && (
                                    <div className="absolute left-0 mt-1 w-56 bg-background border border-border rounded-md shadow-lg z-10">
                                      <div className="py-1">
                                        {gruposCargos
                                          .filter(c => c.id_grupo === grupo?.id)
                                          .map(cargo => {
                                            const isDisabled = (cargo.ordem ?? 0) < ordemCargoAdmin;
                                            return (
                                              <button
                                                key={cargo.id}
                                                disabled={isDisabled}
                                                onClick={() => !isDisabled && handleUpdateMemberCargo(membro.id, cargo.id)}
                                                title={isDisabled ? 'Cargo com hierarquia superior à sua' : undefined}
                                                className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between ${
                                                  isDisabled
                                                    ? 'opacity-40 cursor-not-allowed text-muted-foreground'
                                                    : membro.grupoCargo?.id === cargo.id
                                                      ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
                                                      : 'hover:bg-muted text-foreground'
                                                }`}
                                              >
                                                <span>
                                                  {cargo.cargo}
                                                  {cargo.admin && ' • Admin'}
                                                  {cargo.responsavel && ' • Responsável'}
                                                </span>
                                                {membro.grupoCargo?.id === cargo.id && (
                                                  <div className="w-2 h-2 bg-blue-600 rounded-full" />
                                                )}
                                              </button>
                                            );
                                          })}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <Badge variant="outline">
                                  {membro.grupoCargo?.cargo}
                                  {membro.grupoCargo?.admin && ' • Admin'}
                                  {membro.grupoCargo?.responsavel && ' • Responsável'}
                                </Badge>
                              )}
                            </div>
                            <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
                              <span>Adicionado em {new Date(membro.criado_em).toLocaleDateString('pt-BR')}</span>
                              {membro.militarAdicionou && (
                                <span>
                                  por {membro.militarAdicionou.patente?.abreviacao ? `${membro.militarAdicionou.patente.abreviacao} ` : ''}{membro.militarAdicionou.nick}
                                </span>
                              )}
                              <span className="flex items-center gap-1">
                                <Clock className="h-3.5 w-3.5" />
                                Neste status {getTempoNoStatus(membro.alterado_em)}
                              </span>
                            </div>
                          </div>
                          {canManageMembers(grupoId!) && (
                            <div className="flex flex-wrap gap-2 sm:shrink-0">
                              {(() => {
                                const canRemoveThisMember =
                                  isAdminOfGroup ||
                                  (isResponsavelOfGroup && !membro.grupoCargo?.admin && !membro.grupoCargo?.responsavel);

                                return canRemoveThisMember ? (
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    className="text-red-600 hover:text-red-700 hover:bg-red-50"
                                    onClick={() => handleOpenRemoveModal(membro)}
                                  >
                                    <Trash2 className="h-4 w-4 mr-1" />
                                    Remover
                                  </Button>
                                ) : null;
                              })()}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {activeTab === 'tipos-acoes' && (
          <div className="space-y-6">
            {/* Header com título e botão */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
              <h2 className="text-2xl font-bold text-foreground">Tipos de Ações</h2>
              {canManageActions(grupoId!) && (
                <Button
                  onClick={handleAddTipoAcao}
                  className="bg-green-600 hover:bg-green-700 text-white"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Nova Ação
                </Button>
              )}
            </div>

            {/* Cards de estatísticas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Zap className="h-8 w-8 text-blue-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total</p>
                      <p className="text-2xl font-bold text-foreground">{tiposAcoes.length}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Activity className="h-8 w-8 text-green-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Ações Ativas</p>
                      <p className="text-2xl font-bold text-foreground">{filteredTiposAcoes.length}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Trophy className="h-8 w-8 text-yellow-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Pontuação Total</p>
                      <p className="text-2xl font-bold text-foreground">
                        {tiposAcoes.reduce((sum, t) => sum + (t.pontuacao_meta || 0), 0)}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <BarChart3 className="h-8 w-8 text-purple-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Média de Pontos</p>
                      <p className="text-2xl font-bold text-foreground">
                        {tiposAcoes.length > 0 ? Math.round(tiposAcoes.reduce((sum, t) => sum + (t.pontuacao_meta || 0), 0) / tiposAcoes.length) : 0}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Campo de busca */}
            <div className="flex items-center space-x-4">
              <div className="flex-1 relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <input
                  type="text"
                  placeholder="Buscar tipos de ações..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-border rounded-md bg-background text-foreground focus:ring-ring focus:border-ring"
                />
              </div>
            </div>

            {/* Lista de tipos de ações */}
            <Card>
              <CardHeader>
                <CardTitle>Lista de Tipos de Ações</CardTitle>
              </CardHeader>
              <CardContent>
                {filteredTiposAcoes.length === 0 ? (
                  <div className="text-center py-8">
                    <Zap className="mx-auto h-12 w-12 text-muted-foreground/50" />
                    <h3 className="mt-2 text-sm font-medium text-foreground">
                      {searchTerm ? 'Nenhum tipo de ação encontrado' : 'Nenhum tipo de ação encontrado'}
                    </h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      {searchTerm ? 'Tente buscar com outros termos.' : 'Comece criando um novo tipo de ação.'}
                    </p>
                    {!searchTerm && canManageActions(grupoId!) && (
                      <div className="mt-6">
                        <Button
                          onClick={handleAddTipoAcao}
                          className="bg-green-600 hover:bg-green-700 text-white"
                        >
                          <Plus className="h-4 w-4 mr-2" />
                          Criar Primeiro Tipo de Ação
                        </Button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="space-y-4">
                    {filteredTiposAcoes.map((tipo) => (
                      <div key={tipo.id} className="border border-border rounded-lg p-4 hover:bg-muted/50 dark:hover:bg-muted/30">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-wrap items-center gap-2">
                              <Badge variant="default">Ativo</Badge>
                              <h3 className="text-lg font-medium text-foreground">{tipo.descricao}</h3>
                              <Badge className="bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300">
                                {tipo.pontuacao_meta} pts
                              </Badge>
                            </div>
                            <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
                              <span className="flex items-center">
                                <Target className="h-4 w-4 mr-1" />
                                Meta: {tipo.pontuacao_meta} pontos
                              </span>
                              <span>Criado em {new Date(tipo.criado_em).toLocaleDateString('pt-BR')}</span>
                            </div>
                            {/* Cargos com acesso */}
                            <div className="mt-2 flex flex-wrap items-center gap-1">
                              {tipo.cargos && tipo.cargos.length > 0 ? (
                                <>
                                  <span className="text-xs text-muted-foreground mr-1">Acesso:</span>
                                  {tipo.cargos.map(c => (
                                    <span key={c.id} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300">
                                      {c.cargo.cargo}
                                    </span>
                                  ))}
                                </>
                              ) : (
                                <span className="text-xs text-muted-foreground">Todos os membros</span>
                              )}
                            </div>
                          </div>
                          {canManageActions(grupoId!) && (
                            <div className="flex flex-wrap gap-2 sm:shrink-0">
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => handleOpenCamposModal(tipo)}
                                className="text-purple-600 hover:text-purple-700 hover:bg-purple-50 dark:hover:bg-purple-900/20"
                                title="Configurar campos personalizados"
                              >
                                <Settings className="h-4 w-4 mr-1" />
                                Campos
                              </Button>
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => handleEditTipoAcao(tipo)}
                                className="hover:bg-muted"
                              >
                                <Edit className="h-4 w-4 mr-1" />
                                Editar
                              </Button>
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => handleDeleteTipoAcao(tipo)}
                                className="text-red-600 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/20"
                              >
                                <Trash2 className="h-4 w-4 mr-1" />
                                Excluir
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {activeTab === 'inscricoes' && possuiInscricoes && (
          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-foreground">Inscrições</h2>
            <GrupoInscricoesManager grupoId={grupoId!} isAdmin={isAdminOfGroup} />
          </div>
        )}

        {activeTab === 'ouvidoria' && isAdminOfGroup && possuiOuvidoria && (
          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-foreground">Ouvidoria</h2>
            <GrupoOuvidoriaManager grupoId={grupoId!} isAdmin={isAdminOfGroup} />
          </div>
        )}

        {activeTab === 'fechamentos' && (
          <div className="space-y-6">
            {/* Header com título e botão */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
              <h2 className="text-2xl font-bold text-foreground">Fechamentos</h2>
              {canManageActions(grupoId!) && (
                <Button
                  onClick={handleCreateFechamento}
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Novo Fechamento
                </Button>
              )}
            </div>

            {loadingFechamentos ? (
              <div className="animate-pulse space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
                  {[...Array(4)].map((_, i) => <div key={i} className="h-20 bg-muted rounded" />)}
                </div>
                <div className="h-48 bg-muted rounded" />
              </div>
            ) : (
            <>
            {/* Cards de estatísticas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Archive className="h-8 w-8 text-blue-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total</p>
                      <p className="text-2xl font-bold text-foreground">{fechamentos.length}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Activity className="h-8 w-8 text-green-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Ativos</p>
                      <p className="text-2xl font-bold text-foreground">
                        {fechamentos.filter(f => f.status === 'ativo').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <TrendingUp className="h-8 w-8 text-purple-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total Ações</p>
                      <p className="text-2xl font-bold text-foreground">
                        {fechamentos.reduce((sum, f) => sum + (f.total_acoes || 0), 0)}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Users className="h-8 w-8 text-orange-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total Membros</p>
                      <p className="text-2xl font-bold text-foreground">
                        {fechamentos.reduce((sum, f) => sum + (f.total_membros || 0), 0)}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Filtros de data */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Calendar className="h-5 w-5 text-blue-600" />
                  Filtros de Período
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                  <div className="flex flex-wrap items-center gap-2">
                    <DatePickerField
                      value={fechamentoDateStart}
                      onChange={(value) => setFechamentoDateStart(value)}
                      placeholder="Data inicial"
                    />
                    <span className="text-muted-foreground">até</span>
                    <DatePickerField
                      value={fechamentoDateEnd}
                      onChange={(value) => setFechamentoDateEnd(value)}
                      placeholder="Data final"
                    />
                    {(fechamentoDateStart || fechamentoDateEnd) && (
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => {
                          setFechamentoDateStart('');
                          setFechamentoDateEnd('');
                        }}
                      >
                        Limpar
                      </Button>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Lista de fechamentos */}
            <Card>
              <CardHeader>
                <CardTitle>Lista de Fechamentos</CardTitle>
              </CardHeader>
              <CardContent>
                {filteredFechamentos.length === 0 ? (
                  <div className="text-center py-8">
                    <Archive className="mx-auto h-12 w-12 text-muted-foreground/50" />
                    <h3 className="mt-2 text-sm font-medium text-foreground">
                      {fechamentoDateStart || fechamentoDateEnd ? 'Nenhum fechamento encontrado no período' : 'Nenhum fechamento criado'}
                    </h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      {fechamentoDateStart || fechamentoDateEnd ? 'Tente ajustar o período de busca.' : 'Comece criando um novo fechamento.'}
                    </p>
                    {!(fechamentoDateStart || fechamentoDateEnd) && canManageActions(grupoId!) && (
                      <div className="mt-6">
                        <Button
                          onClick={handleCreateFechamento}
                          className="bg-blue-600 hover:bg-blue-700 text-white"
                        >
                          <Plus className="h-4 w-4 mr-2" />
                          Criar Primeiro Fechamento
                        </Button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="space-y-4">
                    {filteredFechamentos.map((fechamento) => (
                      <div key={fechamento.id} className="border border-border rounded-lg p-4 hover:bg-muted/50 dark:hover:bg-muted/30">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-wrap items-center gap-2">
                              <Badge
                                className={
                                  fechamento.status === 'ativo' ? 'bg-green-100 text-green-800' :
                                  'bg-gray-100 text-gray-800'
                                }
                              >
                                {fechamento.status === 'ativo' ? 'Ativo' : 'Fechado'}
                              </Badge>

                              <h3 className="text-lg font-medium text-foreground">
                                Período: {new Date(fechamento.data_inicio).toLocaleDateString('pt-BR')} - {new Date(fechamento.data_fim).toLocaleDateString('pt-BR')}
                              </h3>
                            </div>

                            <div className="mt-2 grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm text-muted-foreground">
                              <span className="flex items-center">
                                <Activity className="h-4 w-4 mr-1" />
                                {fechamento.total_acoes || 0} ações
                              </span>
                              <span className="flex items-center">
                                <Users className="h-4 w-4 mr-1" />
                                {fechamento.total_membros || 0} membros
                              </span>
                              <span>Fechado em {new Date(fechamento.data_fechamento).toLocaleDateString('pt-BR')}</span>
                              <span>Por: {fechamento.militarCriador?.nick || 'Desconhecido'}</span>
                            </div>

                            {fechamento.observacoes && (
                              <p className="mt-2 text-sm text-muted-foreground">{fechamento.observacoes}</p>
                            )}
                          </div>

                          <div className="flex flex-wrap gap-2 sm:shrink-0">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => handleViewFechamento(fechamento)}
                              className="text-blue-600 hover:text-blue-700 hover:bg-blue-50 dark:hover:bg-blue-900/20"
                            >
                              <Eye className="h-4 w-4 mr-1" />
                              Visualizar
                            </Button>

                            {fechamento.status === 'ativo' && canManageActions(grupoId!) && (
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => handleFinalizarFechamento(fechamento.id)}
                                className="text-purple-600 hover:text-purple-700 hover:bg-purple-50 dark:hover:bg-purple-900/20"
                              >
                                <FileCheck className="h-4 w-4 mr-1" />
                                Finalizar
                              </Button>
                            )}

                            <Button
                              variant="outline"
                              size="sm"
                              className="text-green-600 hover:text-green-700 hover:bg-green-50 dark:hover:bg-green-900/20"
                            >
                              <Download className="h-4 w-4 mr-1" />
                              Exportar
                            </Button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
            </>
            )}
          </div>
        )}

        {/* Tab Gestão de Provas - Apenas para Admins */}
        {activeTab === 'gestao-provas' && canManageGroup && (
          <div className="space-y-6">
            {/* Header com título e botões */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
              <h2 className="text-2xl font-bold text-foreground">Gestão de Provas</h2>
              <div className="flex flex-wrap gap-3">
                <Button
                  onClick={() => setIsCreateProvaModalOpen(true)}
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Nova Prova
                </Button>
              </div>
            </div>

            {/* Cards de estatísticas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Target className="h-8 w-8 text-blue-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total de Provas</p>
                      <p className="text-2xl font-bold text-foreground">{provas.length}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <CheckCircle className="h-8 w-8 text-green-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Provas Ativas</p>
                      <p className="text-2xl font-bold text-foreground">
                        {provas.filter(p => p.ativa).length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Users className="h-8 w-8 text-purple-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total de Acessos</p>
                      <p className="text-2xl font-bold text-foreground">
                        {provas.reduce((total, p) => total + p.total_acessos_concedidos, 0)}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Trophy className="h-8 w-8 text-yellow-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Provas Finalizadas</p>
                      <p className="text-2xl font-bold text-foreground">
                        {provas.reduce((total, p) => total + p.total_provas_finalizadas, 0)}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Campo de busca */}
            <div className="flex items-center space-x-4">
              <div className="flex-1 relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <input
                  type="text"
                  placeholder="Buscar provas..."
                  value={provaSearchTerm}
                  onChange={(e) => setProvaSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-border rounded-md bg-background text-foreground focus:ring-ring focus:border-ring"
                />
              </div>
            </div>

            {/* Lista de Provas */}
            <Card>
              <CardHeader>
                <CardTitle>Provas Criadas</CardTitle>
                <CardDescription>
                  Gerencie as provas, questões e visualize estatísticas detalhadas
                </CardDescription>
              </CardHeader>
              <CardContent>
                {filteredProvas.length === 0 ? (
                  <div className="text-center py-8">
                    <Target className="mx-auto h-12 w-12 text-muted-foreground/50" />
                    <h3 className="mt-2 text-sm font-medium text-foreground">Nenhuma prova encontrada</h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      {provaSearchTerm ? 'Não há provas que correspondam à sua busca.' : 'Comece criando uma nova prova.'}
                    </p>
                    {!provaSearchTerm && (
                      <div className="mt-6">
                        <Button
                          onClick={() => setIsCreateProvaModalOpen(true)}
                          className="bg-blue-600 hover:bg-blue-700 text-white"
                        >
                          <Plus className="h-4 w-4 mr-2" />
                          Nova Prova
                        </Button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="space-y-4">
                    {filteredProvas.map((prova) => (
                      <div key={prova.id} className="border border-border rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-wrap items-center gap-2 mb-2">
                              <h3 className="text-lg font-semibold text-foreground">{prova.titulo}</h3>
                              <Badge className={
                                prova.ativa
                                  ? "bg-green-100 text-green-800 border-green-200 dark:bg-green-900/40 dark:text-green-300 dark:border-green-700"
                                  : "bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700"
                              }>
                                {prova.ativa ? "Ativa" : "Inativa"}
                              </Badge>
                              {prova.resultado_divulgado && (
                                <Badge className="bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/40 dark:text-blue-300 dark:border-blue-700">
                                  Resultados Divulgados
                                </Badge>
                              )}
                            </div>

                            {prova.descricao && (
                              <p className="text-muted-foreground mb-3">{prova.descricao}</p>
                            )}

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                              <div>
                                <span className="text-muted-foreground">Questões na Prova:</span>
                                <p className="font-medium">{prova.total_questoes_prova}</p>
                              </div>
                              <div>
                                <span className="text-muted-foreground">Questões Cadastradas:</span>
                                <p className="font-medium">{prova.total_questoes_cadastradas}</p>
                              </div>
                              <div>
                                <span className="text-muted-foreground">Pontuação Máxima:</span>
                                <p className="font-medium">{prova.pontuacao_maxima}</p>
                              </div>
                              <div>
                                <span className="text-muted-foreground">Tempo Limite:</span>
                                <p className="font-medium">
                                  {prova.tempo_limite_minutos ? `${prova.tempo_limite_minutos} min` : 'Sem limite'}
                                </p>
                              </div>
                              <div>
                                <span className="text-muted-foreground">Acessos Concedidos:</span>
                                <p className="font-medium text-blue-600">{prova.total_acessos_concedidos}</p>
                              </div>
                              <div>
                                <span className="text-muted-foreground">Em Andamento:</span>
                                <p className="font-medium text-orange-600">{prova.total_provas_em_andamento}</p>
                              </div>
                              <div>
                                <span className="text-muted-foreground">Finalizadas:</span>
                                <p className="font-medium text-green-600">{prova.total_provas_finalizadas}</p>
                              </div>
                            </div>
                          </div>

                          <div className="relative sm:ml-4 sm:shrink-0">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => setOpenProvaMenuId(openProvaMenuId === prova.id ? null : prova.id)}
                              className="flex items-center space-x-1"
                            >
                              <Settings className="h-4 w-4" />
                              <span>Ações</span>
                              <ChevronDown className={`h-4 w-4 transition-transform ${openProvaMenuId === prova.id ? 'rotate-180' : ''}`} />
                            </Button>

                            {openProvaMenuId === prova.id && (
                              <>
                                {/* Overlay para fechar o menu quando clicar fora */}
                                <div
                                  className="fixed inset-0 z-10"
                                  onClick={() => setOpenProvaMenuId(null)}
                                />

                                {/* Menu dropdown */}
                                <div className="absolute right-0 top-full mt-1 w-56 bg-background border border-border rounded-lg shadow-lg z-20">
                                  <div className="py-1">
                                    <button
                                      onClick={() => {
                                        setOpenProvaMenuId(null);
                                        handleEditProva(prova);
                                      }}
                                      className="flex items-center w-full px-4 py-2 text-sm text-foreground hover:bg-muted"
                                    >
                                      <Edit className="h-4 w-4 mr-3" />
                                      Editar Prova
                                    </button>

                                    <button
                                      onClick={() => {
                                        setOpenProvaMenuId(null);
                                        setSelectedProvaForQuestoes(prova);
                                        setIsQuestoesManagerOpen(true);
                                      }}
                                      className="flex items-center w-full px-4 py-2 text-sm text-foreground hover:bg-muted"
                                    >
                                      <Target className="h-4 w-4 mr-3" />
                                      Gerenciar Questões
                                    </button>

                                    <button
                                      onClick={() => {
                                        setOpenProvaMenuId(null);
                                        handleGerenciarAcessos(prova);
                                      }}
                                      className="flex items-center w-full px-4 py-2 text-sm text-foreground hover:bg-muted"
                                    >
                                      <Users className="h-4 w-4 mr-3" />
                                      Gerenciar Acessos
                                    </button>

                                    <button
                                      onClick={() => {
                                        setOpenProvaMenuId(null);
                                        setProvaConfirmType('duplicar');
                                        setProvaConfirmTarget(prova);
                                        setProvaConfirmModalOpen(true);
                                      }}
                                      className="flex items-center w-full px-4 py-2 text-sm text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20"
                                    >
                                      <Copy className="h-4 w-4 mr-3" />
                                      Duplicar Prova
                                    </button>

                                    <div className="border-t border-border my-1"></div>

                                    <button
                                      onClick={() => {
                                        setOpenProvaMenuId(null);
                                        setProvaConfirmType('desativar');
                                        setProvaConfirmTarget(prova);
                                        setProvaConfirmModalOpen(true);
                                      }}
                                      className="flex items-center w-full px-4 py-2 text-sm text-foreground hover:bg-muted"
                                    >
                                      {prova.ativa ? (
                                        <>
                                          <XCircle className="h-4 w-4 mr-3" />
                                          Desativar Prova
                                        </>
                                      ) : (
                                        <>
                                          <CheckCircle className="h-4 w-4 mr-3" />
                                          Ativar Prova
                                        </>
                                      )}
                                    </button>

                                    {!prova.resultado_divulgado && prova.total_provas_finalizadas > 0 && (
                                      <button
                                        onClick={() => {
                                          setOpenProvaMenuId(null);
                                          handleDivulgarResultado(prova);
                                        }}
                                        className="flex items-center w-full px-4 py-2 text-sm text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20"
                                      >
                                        <Eye className="h-4 w-4 mr-3" />
                                        Divulgar Resultados
                                      </button>
                                    )}

                                    <div className="border-t border-border my-1"></div>

                                    <button
                                      onClick={() => {
                                        setOpenProvaMenuId(null);
                                        setProvaConfirmType('excluir');
                                        setProvaConfirmTarget(prova);
                                        setProvaConfirmModalOpen(true);
                                      }}
                                      className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20"
                                    >
                                      <Trash2 className="h-4 w-4 mr-3" />
                                      Excluir Prova
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {/* Tab Minhas Provas - Para todos os membros */}
        {activeTab === 'minhas-provas' && (
          <div className="space-y-6">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-2xl font-bold text-foreground">Minhas Provas</h2>
            </div>

            {/* Cards de estatísticas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Trophy className="h-8 w-8 text-blue-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Provas Disponíveis</p>
                      <p className="text-2xl font-bold text-foreground">
                        {filteredMinhasProvas.filter(p => p.status === 'disponivel').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Clock className="h-8 w-8 text-orange-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Em Andamento</p>
                      <p className="text-2xl font-bold text-foreground">
                        {filteredMinhasProvas.filter(p => p.status === 'em_andamento').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <CheckCircle className="h-8 w-8 text-green-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Finalizadas</p>
                      <p className="text-2xl font-bold text-foreground">
                        {filteredMinhasProvas.filter(p => p.status === 'finalizada').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <XCircle className="h-8 w-8 text-red-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Expiradas</p>
                      <p className="text-2xl font-bold text-foreground">
                        {filteredMinhasProvas.filter(p => p.status === 'expirada').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Lista de Provas */}
            <Card>
              <CardHeader>
                <CardTitle>Provas Disponíveis</CardTitle>
                <CardDescription>
                  Visualize e realize as provas disponibilizadas para você
                </CardDescription>
              </CardHeader>
              <CardContent>
                {filteredMinhasProvas.length === 0 ? (
                  <div className="text-center py-8">
                    <Trophy className="mx-auto h-12 w-12 text-muted-foreground/50" />
                    <h3 className="mt-2 text-sm font-medium text-foreground">Nenhuma prova disponível</h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      Quando houver provas disponíveis para você, elas aparecerão aqui.
                    </p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {filteredMinhasProvas.map((acesso) => (
                      <div key={acesso.id} className="border border-border rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-wrap items-center gap-2 mb-2">
                              <h3 className="text-lg font-semibold text-foreground">{acesso.prova.titulo}</h3>
                              <Badge className={
                                acesso.status === 'disponivel'
                                  ? "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/40 dark:text-blue-300 dark:border-blue-700"
                                  : acesso.status === 'em_andamento'
                                  ? "bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/40 dark:text-orange-300 dark:border-orange-700"
                                  : acesso.status === 'finalizada'
                                  ? "bg-green-100 text-green-800 border-green-200 dark:bg-green-900/40 dark:text-green-300 dark:border-green-700"
                                  : "bg-red-100 text-red-800 border-red-200 dark:bg-red-900/40 dark:text-red-300 dark:border-red-700"
                              }>
                                {acesso.status === 'disponivel' && 'Disponível'}
                                {acesso.status === 'em_andamento' && 'Em Andamento'}
                                {acesso.status === 'finalizada' && 'Finalizada'}
                                {acesso.status === 'expirada' && 'Expirada'}
                              </Badge>
                            </div>

                            {acesso.prova.descricao && (
                              <p className="text-muted-foreground mb-3">{acesso.prova.descricao}</p>
                            )}

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                              <div>
                                <span className="text-muted-foreground">Questões:</span>
                                <p className="font-medium">{acesso.prova.total_questoes_prova}</p>
                              </div>
                              <div>
                                <span className="text-muted-foreground">Pontuação Máxima:</span>
                                <p className="font-medium">{acesso.prova.pontuacao_maxima}</p>
                              </div>
                              <div>
                                <span className="text-muted-foreground">Tempo Limite:</span>
                                <p className="font-medium">
                                  {acesso.prova.tempo_limite_minutos ? `${acesso.prova.tempo_limite_minutos} min` : 'Sem limite'}
                                </p>
                              </div>
                              <div>
                                <span className="text-muted-foreground">Resultados:</span>
                                <p className="font-medium">
                                  {acesso.resultado_divulgado ? 'Divulgados' : 'Pendentes'}
                                </p>
                              </div>
                            </div>

                            {acesso.status === 'finalizada' && (
                              <div className="mt-4 text-sm">
                                <div className="grid grid-cols-2 gap-4">
                                  <div>
                                    <span className="text-muted-foreground">Finalizada em:</span>
                                    <p className="font-medium">
                                      {acesso.data_finalizacao
                                        ? new Date(acesso.data_finalizacao).toLocaleString('pt-BR')
                                        : 'Data não informada'
                                      }
                                    </p>
                                  </div>
                                  <div>
                                    <span className="text-muted-foreground">Tempo Gasto:</span>
                                    <p className="font-medium">
                                      {acesso.tempo_gasto_minutos !== null && acesso.tempo_gasto_minutos !== undefined
                                        ? acesso.tempo_gasto_minutos === 0
                                          ? '< 1 min'
                                          : `${acesso.tempo_gasto_minutos} min`
                                        : 'Não informado'}
                                    </p>
                                  </div>
                                </div>

                                {/* Exibir resultado quando divulgado */}
                                {acesso.resultado_divulgado && (
                                  <div className="mt-3 pt-3 border-t">
                                    <div className="flex items-center gap-4 text-sm">
                                      <span className="text-muted-foreground">Resultado:</span>
                                      <span className="font-medium text-blue-600">
                                        {acesso.pontuacao_obtida || 0}/{acesso.prova.pontuacao_maxima} pts
                                      </span>
                                      <span className="text-gray-300">|</span>
                                      <span className="text-green-600">{acesso.acertos || 0} acertos</span>
                                      <span className="text-red-600">{acesso.erros || 0} erros</span>
                                      {(acesso.parciais || 0) > 0 && (
                                        <span className="text-yellow-600">{acesso.parciais} parciais</span>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="flex flex-row flex-wrap gap-2 sm:flex-col sm:ml-4 sm:shrink-0">
                            {acesso.status === 'disponivel' && (
                              <Button
                                className="bg-blue-600 hover:bg-blue-700 text-white"
                                onClick={() => handleIniciarProva(acesso)}
                              >
                                <PlayCircle className="h-4 w-4 mr-1" />
                                Iniciar Prova
                              </Button>
                            )}
                            {acesso.status === 'em_andamento' && (
                              <Button
                                className="bg-orange-600 hover:bg-orange-700 text-white"
                                onClick={() => handleContinuarProva(acesso)}
                              >
                                <PlayCircle className="h-4 w-4 mr-1" />
                                Continuar
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {/* Tab Turmas - Apenas para Admins/Responsáveis */}
        {activeTab === 'turmas' && canManageGroup && (
          <div className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
              <h2 className="text-2xl font-bold text-foreground">Gerenciar Turmas</h2>
              <Button
                onClick={() => setIsTurmaModalOpen(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white"
              >
                <Plus className="h-4 w-4 mr-2" />
                Nova Turma
              </Button>
            </div>

            {/* Cards de estatísticas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <GraduationCap className="h-8 w-8 text-blue-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total de Turmas</p>
                      <p className="text-2xl font-bold text-foreground">{turmas.length}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <CheckCircle className="h-8 w-8 text-green-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Turmas Ativas</p>
                      <p className="text-2xl font-bold text-foreground">
                        {turmas.filter(t => t.ativa).length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Users className="h-8 w-8 text-purple-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total de Membros</p>
                      <p className="text-2xl font-bold text-foreground">
                        {turmas.reduce((total, t) => total + (t.membros?.length || 0), 0)}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Archive className="h-8 w-8 text-gray-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Turmas Finalizadas</p>
                      <p className="text-2xl font-bold text-foreground">
                        {turmas.filter(t => !t.ativa).length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Lista de turmas */}
            <Card>
              <CardHeader>
                <CardTitle>Lista de Turmas</CardTitle>
                <CardDescription>
                  Gerencie as turmas do grupo e seus membros
                </CardDescription>
              </CardHeader>
              <CardContent>
                {turmas.length === 0 ? (
                  <div className="text-center py-8">
                    <GraduationCap className="mx-auto h-12 w-12 text-muted-foreground/50" />
                    <h3 className="mt-2 text-sm font-medium text-foreground">Nenhuma turma criada</h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      Comece criando uma nova turma para organizar seus membros.
                    </p>
                    <div className="mt-6">
                      <Button
                        onClick={() => setIsTurmaModalOpen(true)}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                      >
                        <Plus className="h-4 w-4 mr-2" />
                        Criar Primeira Turma
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {turmas.map((turma) => (
                      <div key={turma.id} className="border rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-semibold text-foreground">{turma.nome}</h3>
                              <Badge className={
                                turma.ativa
                                  ? "bg-green-100 text-green-800 border-green-200 dark:bg-green-900/40 dark:text-green-300 dark:border-green-700"
                                  : "bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700"
                              }>
                                {turma.ativa ? "Ativa" : "Finalizada"}
                              </Badge>
                            </div>
                            {turma.descricao && (
                              <p className="text-sm text-muted-foreground mb-3">{turma.descricao}</p>
                            )}
                            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
                              <span className="flex items-center">
                                <Calendar className="h-4 w-4 mr-1" />
                                {new Date(turma.data_inicio).toLocaleDateString('pt-BR')}
                                {turma.data_fim && ` - ${new Date(turma.data_fim).toLocaleDateString('pt-BR')}`}
                              </span>
                              <span className="flex items-center">
                                <Users className="h-4 w-4 mr-1" />
                                {turma.membros?.length || 0} membros
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-wrap gap-2 sm:shrink-0">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => {
                                setTurmaParaNotas(turma);
                                setIsNotasModalOpen(true);
                              }}
                              className="text-green-600 hover:text-green-700 hover:bg-green-50 dark:text-green-400 dark:hover:bg-green-900/20"
                            >
                              <ClipboardList className="h-4 w-4 mr-1" />
                              Notas
                            </Button>
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => {
                                setTurmaParaMembros(turma);
                                setIsMembrosModalOpen(true);
                              }}
                              className="text-purple-600 hover:text-purple-700 hover:bg-purple-50 dark:text-purple-400 dark:hover:bg-purple-900/20"
                            >
                              <Users className="h-4 w-4 mr-1" />
                              Gerenciar Membros
                            </Button>
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => {
                                setTurmaToEdit(turma);
                                setIsTurmaModalOpen(true);
                              }}
                            >
                              <Edit className="h-4 w-4 mr-1" />
                              Editar
                            </Button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {/* Tab Meus Relatórios */}
        {activeTab === 'meus-relatorios' && (
          <div className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
              <h2 className="text-2xl font-bold text-foreground">Meus Relatórios</h2>
              <Button
                onClick={() => setIsRelatorioModalOpen(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white"
              >
                <Plus className="h-4 w-4 mr-2" />
                Novo Relatório
              </Button>
            </div>

            {/* Cards de estatísticas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <FileText className="h-8 w-8 text-blue-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total</p>
                      <p className="text-2xl font-bold text-foreground">{estatisticasRelatorios?.total || 0}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Edit className="h-8 w-8 text-yellow-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Rascunhos</p>
                      <p className="text-2xl font-bold text-foreground">{estatisticasRelatorios?.rascunhos || 0}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Clock className="h-8 w-8 text-orange-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Enviados</p>
                      <p className="text-2xl font-bold text-foreground">{estatisticasRelatorios?.enviados || 0}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <CheckCircle className="h-8 w-8 text-green-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Confirmados</p>
                      <p className="text-2xl font-bold text-foreground">{estatisticasRelatorios?.confirmados || 0}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Lista de relatórios */}
            <Card>
              <CardHeader>
                <CardTitle>Meus Relatórios</CardTitle>
              </CardHeader>
              <CardContent>
                {meusRelatorios.length === 0 ? (
                  <div className="text-center py-8">
                    <FileText className="mx-auto h-12 w-12 text-muted-foreground/50" />
                    <h3 className="mt-2 text-sm font-medium text-foreground">Nenhum relatório criado</h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      Comece criando seu primeiro relatório.
                    </p>
                    <div className="mt-6">
                      <Button
                        onClick={() => setIsRelatorioModalOpen(true)}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                      >
                        <Plus className="h-4 w-4 mr-2" />
                        Criar Primeiro Relatório
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {meusRelatorios.map((relatorio) => (
                      <div key={relatorio.id} className="border rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-wrap items-center gap-2 mb-2">
                              <h3 className="text-lg font-semibold text-foreground">{relatorio.titulo}</h3>
                              <Badge className={
                                relatorio.status === 'rascunho'
                                  ? "bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/40 dark:text-yellow-300 dark:border-yellow-700"
                                  : relatorio.status === 'enviado'
                                  ? "bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/40 dark:text-orange-300 dark:border-orange-700"
                                  : "bg-green-100 text-green-800 border-green-200 dark:bg-green-900/40 dark:text-green-300 dark:border-green-700"
                              }>
                                {relatorio.status === 'rascunho' ? 'Rascunho' :
                                 relatorio.status === 'enviado' ? 'Enviado' : 'Confirmado'}
                              </Badge>
                              {relatorio.categoria && (
                                <Badge style={{ backgroundColor: getCategoriaInfo(relatorio.categoria).cor + '20', color: getCategoriaInfo(relatorio.categoria).cor, borderColor: getCategoriaInfo(relatorio.categoria).cor }}>
                                  {getCategoriaInfo(relatorio.categoria).nome}
                                </Badge>
                              )}
                            </div>
                            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
                              <span className="flex items-center">
                                <Calendar className="h-4 w-4 mr-1" />
                                {new Date(relatorio.criado_em).toLocaleDateString('pt-BR')}
                              </span>
                              {relatorio.turma && (
                                <span className="flex items-center">
                                  <GraduationCap className="h-4 w-4 mr-1" />
                                  {relatorio.turma.nome}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="flex flex-wrap gap-2 sm:shrink-0">
                            {relatorio.status === 'rascunho' && (
                              <>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => {
                                    setRelatorioToEdit(relatorio);
                                    setIsRelatorioModalOpen(true);
                                  }}
                                >
                                  <Edit className="h-4 w-4 mr-1" />
                                  Editar
                                </Button>
                                <Button
                                  size="sm"
                                  onClick={async () => {
                                    try {
                                      await relatoriosAPI.enviar(relatorio.id);
                                      enqueueSnackbar('Relatório enviado com sucesso!', { variant: 'success' });
                                      loadMeusRelatorios();
                                    } catch (error) {
                                      enqueueSnackbar('Erro ao enviar relatório', { variant: 'error' });
                                    }
                                  }}
                                  className="bg-blue-600 hover:bg-blue-700 text-white"
                                >
                                  <CheckCircle className="h-4 w-4 mr-1" />
                                  Enviar
                                </Button>
                              </>
                            )}
                            {relatorio.status !== 'rascunho' && (
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => {
                                  setRelatorioParaVisualizar(relatorio);
                                  setIsVisualizarRelatorioModalOpen(true);
                                }}
                              >
                                <Eye className="h-4 w-4 mr-1" />
                                Visualizar
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {/* Tab Relatórios - Apenas para Admins/Responsáveis */}
        {activeTab === 'relatorios' && canManageGroup && (
          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <h2 className="text-2xl font-bold text-foreground">Relatórios dos Membros</h2>
            </div>

            {/* Cards de estatísticas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <FileCheck className="h-8 w-8 text-blue-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Total</p>
                      <p className="text-2xl font-bold text-foreground">{relatorios.length}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Clock className="h-8 w-8 text-orange-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Aguardando</p>
                      <p className="text-2xl font-bold text-foreground">
                        {relatorios.filter(r => r.status === 'enviado').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <CheckCircle className="h-8 w-8 text-green-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Confirmados</p>
                      <p className="text-2xl font-bold text-foreground">
                        {relatorios.filter(r => r.status === 'confirmado').length}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4">
                  <div className="flex items-center">
                    <Users className="h-8 w-8 text-purple-600" />
                    <div className="ml-4">
                      <p className="text-sm font-medium text-muted-foreground">Membros Ativos</p>
                      <p className="text-2xl font-bold text-foreground">
                        {new Set(relatorios.map(r => r.id_militar)).size}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Filtros */}
            <Card>
              <CardContent className="pt-6">
                <div className="flex flex-wrap gap-4">
                  <div className="flex-1 min-w-[200px]">
                    <Label htmlFor="filtroTurma">Filtrar por Turma</Label>
                    <select
                      id="filtroTurma"
                      value={filtroTurmaRelatorios}
                      onChange={(e) => setFiltroTurmaRelatorios(e.target.value)}
                      className="w-full mt-1 px-3 py-2 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
                    >
                      <option value="">Todas as turmas</option>
                      {turmas.map((turma) => (
                        <option key={turma.id} value={turma.id}>
                          {turma.nome} {turma.ativa ? '(Ativa)' : ''}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex-1 min-w-[200px]">
                    <Label htmlFor="filtroCategoria">Filtrar por Categoria</Label>
                    <select
                      id="filtroCategoria"
                      value={filtroCategoriaRelatorios}
                      onChange={(e) => setFiltroCategoriaRelatorios(e.target.value)}
                      className="w-full mt-1 px-3 py-2 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
                    >
                      <option value="">Todas as categorias</option>
                      <option value="aula">Aula</option>
                      <option value="atividade">Atividade</option>
                      <option value="projeto">Projeto</option>
                    </select>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Lista de relatórios */}
            <Card>
              <CardHeader>
                <CardTitle>Relatórios Recebidos</CardTitle>
                <CardDescription>
                  Visualize e confirme os relatórios enviados pelos membros
                </CardDescription>
              </CardHeader>
              <CardContent>
                {relatorios
                  .filter(r => !filtroTurmaRelatorios || r.id_turma === filtroTurmaRelatorios)
                  .filter(r => !filtroCategoriaRelatorios || r.categoria === filtroCategoriaRelatorios)
                  .length === 0 ? (
                  <div className="text-center py-8">
                    <FileCheck className="mx-auto h-12 w-12 text-muted-foreground/50" />
                    <h3 className="mt-2 text-sm font-medium text-foreground">Nenhum relatório encontrado</h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      {relatorios.length > 0
                        ? "Nenhum relatório corresponde aos filtros selecionados."
                        : "Quando os membros enviarem relatórios, eles aparecerão aqui."}
                    </p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {relatorios
                      .filter(r => !filtroTurmaRelatorios || r.id_turma === filtroTurmaRelatorios)
                      .filter(r => !filtroCategoriaRelatorios || r.categoria === filtroCategoriaRelatorios)
                      .map((relatorio) => (
                      <div key={relatorio.id} className="border rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-wrap items-center gap-2 mb-2">
                              <h3 className="text-lg font-semibold text-foreground">{relatorio.titulo}</h3>
                              <Badge className={
                                relatorio.status === 'rascunho'
                                  ? "bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/40 dark:text-yellow-300 dark:border-yellow-700"
                                  : relatorio.status === 'enviado'
                                  ? "bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/40 dark:text-orange-300 dark:border-orange-700"
                                  : "bg-green-100 text-green-800 border-green-200 dark:bg-green-900/40 dark:text-green-300 dark:border-green-700"
                              }>
                                {relatorio.status === 'rascunho' ? 'Rascunho' :
                                 relatorio.status === 'enviado' ? 'Enviado' : 'Confirmado'}
                              </Badge>
                              {relatorio.categoria && (
                                <Badge style={{ backgroundColor: getCategoriaInfo(relatorio.categoria).cor + '20', color: getCategoriaInfo(relatorio.categoria).cor, borderColor: getCategoriaInfo(relatorio.categoria).cor }}>
                                  {getCategoriaInfo(relatorio.categoria).nome}
                                </Badge>
                              )}
                            </div>
                            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground mb-2">
                              <span className="flex items-center font-medium">
                                <Users className="h-4 w-4 mr-1" />
                                {relatorio.militar?.nick || 'Desconhecido'}
                              </span>
                              <span className="flex items-center">
                                <Calendar className="h-4 w-4 mr-1" />
                                {new Date(relatorio.criado_em).toLocaleDateString('pt-BR')}
                              </span>
                              {relatorio.turma && (
                                <span className="flex items-center">
                                  <GraduationCap className="h-4 w-4 mr-1" />
                                  {relatorio.turma.nome}
                                </span>
                              )}
                            </div>
                            {relatorio.status === 'confirmado' && relatorio.confirmado_por && (
                              <div className="flex items-center space-x-2 text-xs text-green-700 dark:text-green-400 bg-green-50 dark:bg-green-900/30 rounded px-2 py-1 w-fit">
                                <CheckCircle className="h-3 w-3" />
                                <span>Confirmado por {relatorio.confirmado_por.nick}</span>
                              </div>
                            )}
                          </div>
                          <div className="flex flex-wrap gap-2 sm:shrink-0">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => {
                                setRelatorioParaVisualizar(relatorio);
                                setIsVisualizarRelatorioModalOpen(true);
                              }}
                            >
                              <Eye className="h-4 w-4 mr-1" />
                              Visualizar
                            </Button>
                            {relatorio.status === 'enviado' && (
                              <Button
                                size="sm"
                                onClick={() => {
                                  setRelatorioToConfirmar(relatorio);
                                  setIsConfirmarRelatorioModalOpen(true);
                                }}
                                className="bg-green-600 hover:bg-green-700 text-white"
                              >
                                <CheckCircle className="h-4 w-4 mr-1" />
                                Confirmar
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}
      </div>

      {/* Modal de Gerenciar Membros */}
      {grupo && (
        <GrupoMembrosModal
          isOpen={isGrupoMembrosModalOpen}
          onClose={() => {
            setIsGrupoMembrosModalOpen(false);
            setOpenMembrosModalInAddMode(false);
          }}
          onUpdate={loadMembros}
          grupo={grupo}
          gruposCargos={gruposCargos}
          openDirectlyInAddMode={openMembrosModalInAddMode}
          isResponsavel={isResponsavelOfGroup && !isAdminOfGroup}
          ordemCargoAdmin={isAdminOfGroup ? ordemCargoAdmin : undefined}
        />
      )}

      {/* Modal de Tipos de Ações */}
      {grupo && (
        <TipoAcaoModal
          open={isTipoAcaoModalOpen}
          onClose={() => {
            setIsTipoAcaoModalOpen(false);
            setTipoAcaoToEdit(null);
          }}
          onSuccess={handleTipoAcaoModalSuccess}
          grupoId={grupoId!}
          tipoAcaoToEdit={tipoAcaoToEdit}
        />
      )}

      {/* Modal de Confirmação de Exclusão */}
      {deleteConfirmOpen && tipoAcaoToDelete && (
        <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center">
          <div className="bg-card border border-border rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex-shrink-0 w-10 h-10 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
                <Trash2 className="w-5 h-5 text-red-600 dark:text-red-400" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-foreground">Confirmar Exclusão</h2>
                <p className="text-sm text-muted-foreground">Esta ação não pode ser desfeita.</p>
              </div>
            </div>

            <p className="text-sm text-muted-foreground mb-6">
              Tem certeza que deseja excluir a ação{' '}
              <span className="font-semibold text-foreground">"{tipoAcaoToDelete.descricao}"</span>?
              {' '}Todos os dados relacionados serão perdidos.
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setDeleteConfirmOpen(false);
                  setTipoAcaoToDelete(null);
                }}
                className="px-4 py-2 text-sm font-medium text-muted-foreground border border-border rounded-md hover:bg-muted transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={handleConfirmDelete}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md transition-colors"
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Remoção de Membro */}
      {removeMembroModalOpen && membroToRemove && (
        <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center">
          <div className="bg-card border border-border rounded-lg shadow-lg p-6 w-full max-w-md mx-4">
            <div className="flex items-center space-x-3 mb-4">
              <AlertTriangle className="w-6 h-6 text-red-500" />
              <h2 className="text-xl font-semibold text-foreground">Remover Membro</h2>
            </div>

            <div className="mb-6">
              <p className="text-muted-foreground mb-4">
                Tem certeza que deseja remover <strong>{membroToRemove.militar.patente?.abreviacao} {membroToRemove.militar.nick}</strong> do grupo?
              </p>
              <p className="text-sm text-muted-foreground mb-4">
                O membro será removido logicamente, mantendo o histórico de suas ações no grupo.
              </p>

              <div className="space-y-2">
                <Label htmlFor="motivoRemocao" className="text-sm font-medium text-foreground">
                  Motivo da remoção (opcional)
                </Label>
                <textarea
                  id="motivoRemocao"
                  value={motivoRemocao}
                  onChange={(e) => setMotivoRemocao(e.target.value)}
                  placeholder="Digite o motivo da remoção..."
                  className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-red-500 resize-none"
                  rows={3}
                />
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <Button
                variant="outline"
                onClick={handleCloseRemoveModal}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleRemoveMember}
                className="bg-red-600 hover:bg-red-700 text-white"
              >
                <Trash2 className="w-4 h-4 mr-2" />
                Remover Membro
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação — Provas (Duplicar / Desativar / Excluir) */}
      {provaConfirmModalOpen && provaConfirmTarget && (
        <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center">
          <div className="bg-card border border-border rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
            <div className="flex items-center gap-3 mb-4">
              <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${
                provaConfirmType === 'excluir'
                  ? 'bg-red-100 dark:bg-red-900/30'
                  : provaConfirmType === 'duplicar'
                  ? 'bg-blue-100 dark:bg-blue-900/30'
                  : 'bg-yellow-100 dark:bg-yellow-900/30'
              }`}>
                {provaConfirmType === 'excluir' && <Trash2 className="w-5 h-5 text-red-600 dark:text-red-400" />}
                {provaConfirmType === 'duplicar' && <Copy className="w-5 h-5 text-blue-600 dark:text-blue-400" />}
                {provaConfirmType === 'desativar' && (
                  provaConfirmTarget.ativa
                    ? <XCircle className="w-5 h-5 text-yellow-600 dark:text-yellow-400" />
                    : <CheckCircle className="w-5 h-5 text-yellow-600 dark:text-yellow-400" />
                )}
              </div>
              <div>
                <h2 className="text-lg font-semibold text-foreground">
                  {provaConfirmType === 'excluir' && 'Excluir Prova'}
                  {provaConfirmType === 'duplicar' && 'Duplicar Prova'}
                  {provaConfirmType === 'desativar' && (provaConfirmTarget.ativa ? 'Desativar Prova' : 'Ativar Prova')}
                </h2>
                <p className="text-sm text-muted-foreground">Esta ação não pode ser desfeita.</p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-6">
              {provaConfirmType === 'excluir' && <>Tem certeza que deseja excluir a prova <span className="font-semibold text-foreground">"{provaConfirmTarget.titulo}"</span>? Todos os dados relacionados serão perdidos.</>}
              {provaConfirmType === 'duplicar' && <>Deseja criar uma cópia da prova <span className="font-semibold text-foreground">"{provaConfirmTarget.titulo}"</span>?</>}
              {provaConfirmType === 'desativar' && (provaConfirmTarget.ativa
                ? <>Deseja desativar a prova <span className="font-semibold text-foreground">"{provaConfirmTarget.titulo}"</span>? Os membros não poderão mais acessá-la.</>
                : <>Deseja ativar a prova <span className="font-semibold text-foreground">"{provaConfirmTarget.titulo}"</span>?</>
              )}
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => { setProvaConfirmModalOpen(false); setProvaConfirmTarget(null); setProvaConfirmType(null); }}
                className="px-4 py-2 text-sm font-medium text-muted-foreground border border-border rounded-md hover:bg-muted transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  if (provaConfirmType === 'excluir') handleDeleteProva(provaConfirmTarget);
                  else if (provaConfirmType === 'duplicar') handleDuplicarProva(provaConfirmTarget);
                  else if (provaConfirmType === 'desativar') handleToggleProvaStatus(provaConfirmTarget);
                  setProvaConfirmModalOpen(false);
                  setProvaConfirmTarget(null);
                  setProvaConfirmType(null);
                }}
                className={`px-4 py-2 text-sm font-medium text-white rounded-md transition-colors ${
                  provaConfirmType === 'excluir'
                    ? 'bg-red-600 hover:bg-red-700'
                    : provaConfirmType === 'duplicar'
                    ? 'bg-blue-600 hover:bg-blue-700'
                    : 'bg-yellow-600 hover:bg-yellow-700'
                }`}
              >
                {provaConfirmType === 'excluir' && 'Excluir'}
                {provaConfirmType === 'duplicar' && 'Duplicar'}
                {provaConfirmType === 'desativar' && (provaConfirmTarget.ativa ? 'Desativar' : 'Ativar')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação — Confirmar Relatório */}
      {isConfirmarRelatorioModalOpen && relatorioToConfirmar && (
        <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center">
          <div className="bg-card border border-border rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center">
                <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-foreground">Confirmar Relatório</h2>
                <p className="text-sm text-muted-foreground">Esta ação não pode ser desfeita.</p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-6">
              Deseja confirmar o relatório <span className="font-semibold text-foreground">"{relatorioToConfirmar.titulo}"</span> de <span className="font-semibold text-foreground">{relatorioToConfirmar.militar?.nick}</span>?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => { setIsConfirmarRelatorioModalOpen(false); setRelatorioToConfirmar(null); }}
                className="px-4 py-2 text-sm font-medium text-muted-foreground border border-border rounded-md hover:bg-muted transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={async () => {
                  try {
                    await relatoriosAPI.confirmar(relatorioToConfirmar.id);
                    enqueueSnackbar('Relatório confirmado com sucesso!', { variant: 'success' });
                    loadRelatorios();
                  } catch (error) {
                    enqueueSnackbar('Erro ao confirmar relatório', { variant: 'error' });
                  } finally {
                    setIsConfirmarRelatorioModalOpen(false);
                    setRelatorioToConfirmar(null);
                  }
                }}
                className="px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-md transition-colors"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Configuração de Campos */}
      {tipoAcaoParaCampos && (
        <CampoAcaoModal
          open={campoModalOpen}
          onClose={handleCloseCamposModal}
          onSuccess={handleCamposModalSuccess}
          tipoAcaoId={tipoAcaoParaCampos.id}
          tipoAcaoDescricao={tipoAcaoParaCampos.descricao}
        />
      )}

      {/* Modal de Criação/Edição de Guia */}
      {isGuiaModalOpen && (
        <GrupoGuiaModal
          isOpen={isGuiaModalOpen}
          onClose={handleGuiaModalClose}
          onSave={handleGuiaModalSave}
          guia={selectedGuia}
          grupoId={grupoId!}
          categorias={[]} // Pode ser carregado dinamicamente se necessário
        />
      )}

      {/* Visualizador de Guia */}
      <GuiaViewer
        isOpen={isGuiaViewerOpen}
        onClose={handleGuiaViewerClose}
        guiaId={viewingGuiaId}
      />

      {/* Visualizador de Guia em Janela Flutuante (PIP) */}
      {pipGuiaId && (
        <GuiaViewerPIP
          guiaId={pipGuiaId}
          onClose={() => setPipGuiaId(null)}
        />
      )}

      {/* Modal de Confirmação de Exclusão de Guia */}
      {guiaToDeletePage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setGuiaToDeletePage(null)}
          />
          <div className="relative z-10 bg-card border border-border rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex-shrink-0 w-10 h-10 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
                <Trash2 className="h-5 w-5 text-red-600 dark:text-red-400" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground">Excluir Guia</h3>
                <p className="text-sm text-muted-foreground">Esta ação não pode ser desfeita.</p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-6">
              Tem certeza que deseja excluir a guia{' '}
              <span className="font-semibold text-foreground">"{guiaToDeletePage.titulo}"</span>?
            </p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => setGuiaToDeletePage(null)}
                className="px-4 py-2 text-sm font-medium text-muted-foreground border border-border rounded-md hover:bg-muted transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={handleConfirmDeleteGuia}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md transition-colors"
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Criação de Fechamento */}
      <CreateFechamentoModal
        isOpen={isFechamentoModalOpen}
        onClose={handleFechamentoModalClose}
        onSave={handleFechamentoModalSave}
        grupoId={grupoId!}
      />

      {/* Modal de Visualização de Fechamento */}
      {selectedFechamento && (
        <VisualizarFechamentoModal
          isOpen={isVisualizarFechamentoModalOpen}
          onClose={handleVisualizarFechamentoModalClose}
          fechamentoId={selectedFechamento.id}
        />
      )}

      {/* Modal de Criação de Prova */}
      {isCreateProvaModalOpen && (
        <CreateProvaModal
          isOpen={isCreateProvaModalOpen}
          onClose={() => setIsCreateProvaModalOpen(false)}
          onSave={handleCreateProva}
          loading={loadingProvas}
        />
      )}

      {/* Modal de Edição de Prova */}
      {provaToEdit && (
        <EditProvaModal
          isOpen={!!provaToEdit}
          onClose={() => setProvaToEdit(null)}
          onSave={handleUpdateProva}
          loading={loadingProvas}
          prova={provaToEdit}
        />
      )}

      {/* Modal de Gerenciamento de Questões */}
      {isQuestoesManagerOpen && selectedProvaForQuestoes && (
        <QuestoesManager
          provaId={selectedProvaForQuestoes.id}
          provaTitle={selectedProvaForQuestoes.titulo}
          isOpen={isQuestoesManagerOpen}
          onClose={() => {
            setIsQuestoesManagerOpen(false);
            setSelectedProvaForQuestoes(null);
          }}
        />
      )}

      {/* Modal de Gerenciamento de Acessos */}
      {isGerenciarAcessosModalOpen && selectedProvaForAcessos && (
        <GerenciarAcessosModal
          isOpen={isGerenciarAcessosModalOpen}
          onClose={() => {
            setIsGerenciarAcessosModalOpen(false);
            setSelectedProvaForAcessos(null);
          }}
          prova={selectedProvaForAcessos}
        />
      )}

      {/* Modal de Realizar Prova */}
      {acessoParaRealizar && (
        <RealizarProvaModal
          isOpen={isRealizarProvaModalOpen}
          onClose={() => {
            setIsRealizarProvaModalOpen(false);
            setAcessoParaRealizar(null);
          }}
          prova={acessoParaRealizar}
          onProvaFinalizada={handleFinalizarProva}
        />
      )}

      {provaParaDivulgarResultados && (
        <DivulgarResultadosModal
          isOpen={isDivulgarResultadosModalOpen}
          onClose={() => {
            setIsDivulgarResultadosModalOpen(false);
            setProvaParaDivulgarResultados(null);
          }}
          prova={provaParaDivulgarResultados}
          onResultadoDivulgado={() => {
            loadProvas();
            enqueueSnackbar('Resultado divulgado com sucesso!', { variant: 'success' });
          }}
        />
      )}

      {/* Modal de Turma */}
      {isTurmaModalOpen && grupoId && (
        <TurmaModal
          isOpen={isTurmaModalOpen}
          onClose={() => {
            setIsTurmaModalOpen(false);
            setTurmaToEdit(null);
          }}
          idGrupo={grupoId}
          editingTurma={turmaToEdit}
          onSuccess={() => {
            loadTurmas();
            setIsTurmaModalOpen(false);
            setTurmaToEdit(null);
          }}
        />
      )}

      {/* Modal de Gerenciar Membros da Turma */}
      {isMembrosModalOpen && turmaParaMembros && grupoId && (
        <GerenciarMembrosModal
          isOpen={isMembrosModalOpen}
          onClose={() => {
            setIsMembrosModalOpen(false);
            setTurmaParaMembros(null);
          }}
          idGrupo={grupoId}
          turma={turmaParaMembros}
          onSuccess={() => {
            loadTurmas();
            setIsMembrosModalOpen(false);
            setTurmaParaMembros(null);
          }}
        />
      )}

      {/* Modal de Relatório */}
      {isRelatorioModalOpen && grupoId && (
        <RelatorioModal
          isOpen={isRelatorioModalOpen}
          onClose={() => {
            setIsRelatorioModalOpen(false);
            setRelatorioToEdit(null);
          }}
          idGrupo={grupoId}
          editingRelatorio={relatorioToEdit}
          onSuccess={() => {
            loadMeusRelatorios();
            if (canManageGroup) {
              loadRelatorios();
            }
            setIsRelatorioModalOpen(false);
            setRelatorioToEdit(null);
          }}
        />
      )}

      {/* Modal de Visualizar Relatório */}
      {isVisualizarRelatorioModalOpen && relatorioParaVisualizar && grupoId && (
        <VisualizarRelatorioModal
          isOpen={isVisualizarRelatorioModalOpen}
          onClose={() => {
            setIsVisualizarRelatorioModalOpen(false);
            setRelatorioParaVisualizar(null);
          }}
          idGrupo={grupoId}
          relatorio={relatorioParaVisualizar}
          canConfirm={canManageGroup}
          onSuccess={() => {
            loadMeusRelatorios();
            if (canManageGroup) {
              loadRelatorios();
            }
            setIsVisualizarRelatorioModalOpen(false);
            setRelatorioParaVisualizar(null);
          }}
        />
      )}

      {/* Modal de Gerenciar Notas da Turma */}
      {isNotasModalOpen && turmaParaNotas && (
        <GerenciarNotasModal
          isOpen={isNotasModalOpen}
          onClose={() => {
            setIsNotasModalOpen(false);
            setTurmaParaNotas(null);
          }}
          turma={turmaParaNotas}
        />
      )}
    </div>
  );
}
